document.querySelectorAll('[data-song-3d-pillow]').forEach((customizerRoot) => {
        if (customizerRoot.dataset.song3dInitialized === "true") return;
        customizerRoot.dataset.song3dInitialized = "true";
        const fileInput    = customizerRoot.querySelector("#fileInput");
        const uploadBtn    = customizerRoot.querySelector("#uploadBtn");
        const progressWrap = customizerRoot.querySelector("#progressWrap");
        const progressBar  = customizerRoot.querySelector("#progressBar");
        const statusSpinner= customizerRoot.querySelector("#statusSpinner");
        const statusText   = customizerRoot.querySelector("#statusText");
        const previewCanvas= customizerRoot.querySelector("#previewCanvas");
        const modelPreview = customizerRoot.querySelector("#modelPreview");
        const stageBackgroundScene = customizerRoot.querySelector("#stageBackgroundScene");
        const stageModelPreview = customizerRoot.querySelector("#stageModelPreview");
        const stageBackgroundScene2 = customizerRoot.querySelector("#stageBackgroundScene2");
        const stageModelPreview2 = customizerRoot.querySelector("#stageModelPreview2");
        const tab3d = customizerRoot.querySelector("#tab3d");
        const tabBackground = customizerRoot.querySelector("#tabBackground");
        const stage3d      = customizerRoot.querySelector("#stage3d");
        const dropHint = customizerRoot.querySelector("#dropHint");
        const dropHintHitarea = customizerRoot.querySelector(".drop-hint-hitarea");
        const customizerPanel = customizerRoot.querySelector("#customizerPanel");
        const mediaShell = customizerRoot.querySelector("#mediaShell");

        const stageLoadingOverlay = customizerRoot.querySelector("#stageLoadingOverlay");
        const stageLoadingText = customizerRoot.querySelector("#stageLoadingText");
        const stageLoadingProgressBar = customizerRoot.querySelector("#stageLoadingProgressBar");
        const viewerStageHost = customizerRoot.querySelector("#viewerStageHost");
        const statusHost = customizerRoot.querySelector("#statusHost");
        const previewHost = customizerRoot.querySelector("#previewHost");
        const historyPanel = customizerRoot.querySelector("#historyPanel");
        const historyList = customizerRoot.querySelector("#historyList");
        const productForm = customizerRoot.querySelector('product-form form[data-type="add-to-cart-form"]');
        const variantIdInput = productForm?.querySelector(".product-variant-id");
        const productSubmitButton = customizerRoot.querySelector(".product-form__submit");
        const productSubmitText = customizerRoot.querySelector(".product-form__submit span");
        const cartButtonLabel = customizerRoot.dataset.cartButtonLabel || "";
        const moneyFormat = customizerRoot.dataset.moneyFormat || "${{amount}}";
        const showMediaShell = customizerRoot.dataset.showMediaShell === "true";
        const showHistory = customizerRoot.dataset.showHistory !== "false";
        const autoRotateEnabled = customizerRoot.dataset.autoRotateEnabled === "true";
        const cartButtonPrefix = (cartButtonLabel || "ADD TO CART").replace(/\s*[$€£¥₹₩₽][\d\s.,]+.*$/, "").trim() || "ADD TO CART";
        const moneyFormatText = moneyFormat.replace(/<[^>]*>/g, "");
        const variantOptionsRoot = customizerRoot.querySelector("[data-variant-options]");
        const variantDataNode = customizerRoot.querySelector("[data-product-variants-json]");
        const legacyStatusBar = customizerRoot.querySelector("#statusBar");
        const legacyPreviewGrid = customizerRoot.querySelector(".preview-grid");
        const colorSwatches = [...customizerRoot.querySelectorAll("[data-pillow-color]")];
        const modelPreviewWrap = modelPreview?.closest(".preview-wrap");

        function setModelPreviewState(dataUrl = "") {
            if (modelPreview) {
                if (dataUrl) {
                    modelPreview.src = dataUrl;
                    modelPreview.hidden = false;
                } else {
                    modelPreview.hidden = true;
                    modelPreview.removeAttribute("src");
                }
            }
            if (stageModelPreview) {
                if (dataUrl) {
                    stageModelPreview.src = dataUrl;
                } else {
                    stageModelPreview.removeAttribute("src");
                }
            }
            if (stageModelPreview2) {
                if (dataUrl) {
                    stageModelPreview2.src = dataUrl;
                } else {
                    stageModelPreview2.removeAttribute("src");
                }
            }
        }

        function getSelectedPillowSize() {
            const activeOption = document.querySelector('.variant-option-button.is-active');
            if (!activeOption) return null;
            
            const optionValue = activeOption.dataset.optionValue || activeOption.textContent;
            
            const sizeMatch = optionValue.match(/(\d+(?:\.\d+)?)[x×*×](\d+(?:\.\d+)?)?/);
            if (sizeMatch) {
                const height = parseFloat(sizeMatch[2]) || parseFloat(sizeMatch[1]);
                return height;
            }
            
            const numberMatch = optionValue.match(/(\d+(?:\.\d+)?)[\s-]*(cm|inch|cm\/|inch\/)?/i);
            if (numberMatch) {
                return parseFloat(numberMatch[1]);
            }
            
            const pureNumberMatch = optionValue.match(/(\d{1,3})/);
            if (pureNumberMatch) {
                return parseFloat(pureNumberMatch[1]);
            }
            
            return null;
        }

        function show3dScene() {
            if (!tab3d) return;
            
            if (stageBackgroundScene) {
                stageBackgroundScene.classList.add('hidden');
            }
            if (stageBackgroundScene2) {
                stageBackgroundScene2.classList.add('hidden');
            }
            tab3d.classList.add('is-active');
            if (tabBackground) {
                tabBackground.classList.remove('is-active');
            }
        }

        function showBackgroundScene() {
            if (!tab3d || !tabBackground) return;

            tab3d.classList.remove('is-active');
            tabBackground.classList.add('is-active');
            updateStageModelPreviewSize();
        }

        function toggleBackgroundScene() {
            if (!stageBackgroundScene) return;
            
            const isHidden = stageBackgroundScene.classList.contains('hidden');
            if (isHidden) {
                showBackgroundScene();
            } else {
                show3dScene();
            }
        }

        function updateStageModelPreviewSize() {
            const selectedPillowSize = getSelectedPillowSize();
            if (!selectedPillowSize) return;

            // 获取尺寸阈值（默认50）
            let sizeThreshold = 50;
            if (stageBackgroundScene && stageBackgroundScene.dataset.sizeThreshold) {
                sizeThreshold = parseFloat(stageBackgroundScene.dataset.sizeThreshold) || 50;
            }

            // 根据规格大小和可用性选择背景图
            let useSecondBackground = selectedPillowSize < sizeThreshold;
            let currentBackgroundScene = useSecondBackground ? stageBackgroundScene2 : stageBackgroundScene;
            let currentModelPreview = useSecondBackground ? stageModelPreview2 : stageModelPreview;

            // 如果选中的背景图不存在，使用另一个
            if (!currentBackgroundScene || !currentModelPreview) {
                useSecondBackground = !useSecondBackground;
                currentBackgroundScene = useSecondBackground ? stageBackgroundScene2 : stageBackgroundScene;
                currentModelPreview = useSecondBackground ? stageModelPreview2 : stageModelPreview;
            }

            // 如果还是没有可用的背景图，返回
            if (!currentBackgroundScene || !currentModelPreview) return;

            const personRatioStr = currentBackgroundScene.dataset.personRatio || "4:5";
            const personHeightCm = parseFloat(currentBackgroundScene.dataset.personHeightCm) || (useSecondBackground ? 120 : 160);

            const ratioParts = personRatioStr.split(":");
            const personRatio = parseFloat(ratioParts[0]) || 4;
            const backgroundRatio = parseFloat(ratioParts[1]) || 5;

            const backgroundHeightCm = (personHeightCm / personRatio) * backgroundRatio;

            const scale = (selectedPillowSize / backgroundHeightCm) * 100;

            console.log('updateStageModelPreviewSize:', {
                useSecondBackground,
                sizeThreshold,
                personRatioStr,
                personHeightCm,
                personRatio,
                backgroundRatio,
                backgroundHeightCm,
                selectedPillowSize,
                scale
            });

            // 隐藏所有背景场景
            if (stageBackgroundScene) stageBackgroundScene.classList.add('hidden');
            if (stageBackgroundScene2) stageBackgroundScene2.classList.add('hidden');

            // 显示当前背景场景
            currentBackgroundScene.classList.remove('hidden');

            // 更新模型预览大小
            currentModelPreview.style.height = `${scale}%`;
            currentModelPreview.style.width = `${scale}%`;

            // 根据后台设置更新模型底部位置
            const modelBottomPosition = currentBackgroundScene.dataset.modelBottomPosition || 30;
            currentModelPreview.style.bottom = `${modelBottomPosition}%`;

            // 根据后台设置更新模型右边位置
            const modelRightPosition = currentBackgroundScene.dataset.modelRightPosition || 50;
            currentModelPreview.style.right = `${modelRightPosition}%`;
        }

        function setModelPreviewLoading(loading) {
            if (!modelPreviewWrap) return;
            modelPreviewWrap.classList.toggle("is-loading", loading);
            modelPreviewWrap.setAttribute("aria-busy", loading ? "true" : "false");
        }

        function setDropHintCompactState(compact) {
            dropHint?.classList.toggle("is-compact", compact);
        }

        function setMediaShellState(visible) {
            if (mediaShell) mediaShell.hidden = !visible;
            customizerPanel?.classList.toggle("is-hidden", visible);
            customizerPanel?.setAttribute("aria-hidden", visible ? "true" : "false");
            // Initialize 3D scene only when panel actually becomes visible
            // (avoids creating WebGL renderer in a display:none container with 0x0 size)
            if (!visible && stage3d && !renderer) {
                initThreeScene();
            }
        }

        if (viewerStageHost && stage3d) viewerStageHost.appendChild(stage3d);
        if (statusHost && progressWrap) statusHost.appendChild(progressWrap);
        if (statusHost && legacyStatusBar) statusHost.appendChild(legacyStatusBar);
        if (previewHost && legacyPreviewGrid) previewHost.appendChild(legacyPreviewGrid);

        setModelPreviewState("");
        setModelPreviewLoading(false);
        setDropHintCompactState(false);
        setMediaShellState(showMediaShell);
        if (productForm && fileInput) {
            fileInput.name = "properties[Custom image]";
            productForm.appendChild(fileInput);
        }
        if (fileInput) {
            const openFilePicker = () => fileInput.click();
            dropHintHitarea?.addEventListener("click", openFilePicker);
            dropHintHitarea?.addEventListener("keydown", (event) => {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    openFilePicker();
                }
            });
            customizerRoot.querySelectorAll(".media-shell__upload-trigger").forEach(btn => btn.addEventListener("click", openFilePicker));
        }
        if (productSubmitText && cartButtonLabel && !customizerRoot.querySelector(".product-form__submit[disabled]")) {
            productSubmitText.textContent = cartButtonLabel;
        }

        if (productForm) {
            productForm.addEventListener("submit", async (event) => {
                if (allowNativeCartSubmit) {
                    allowNativeCartSubmit = false;
                    return;
                }
                if (isPreparingCartSubmit) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    return;
                }

                event.preventDefault();
                event.stopImmediatePropagation();
                isPreparingCartSubmit = true;

                try {
                    await syncLatestDesignForCart();
                    if (currentRawCutoutCanvas && !uploadedCutoutUrl) {
                        setStatus("Uploading cutout image...", true);
                        updateCustomizerProperties();
                        await uploadCutoutCanvas(currentRawCutoutCanvas);
                        hideProgress();
                        setStatus("Cutout image uploaded.");
                    }
                    if (!uploadedModelUrl) {
                        setStatus("Uploading 3D model image...", true);
                        updateCustomizerProperties();
                        const modelImageDataUrl = captureTransparentModelImage(MODEL_UPLOAD_IMAGE_SIZE);
                        if (modelImageDataUrl) {
                            const modelCanvas = document.createElement("canvas");
                            const img = new Image();
                            img.src = modelImageDataUrl;
                            await new Promise((resolve) => { img.onload = resolve; });
                            modelCanvas.width = img.width;
                            modelCanvas.height = img.height;
                            modelCanvas.getContext("2d").drawImage(img, 0, 0);
                            await uploadModelCanvas(modelCanvas);
                        }
                        hideProgress();
                        setStatus("3D model image uploaded.");
                    }
                    if (selectedFile && !uploadedOriginalUrl) {
                        setStatus("Uploading original image...", true);
                        await uploadOriginalFile();
                        hideProgress();
                        setStatus("Original image uploaded.");
                    }
                    allowNativeCartSubmit = true;
                    isPreparingCartSubmit = false;
                    productForm.requestSubmit(productSubmitButton || undefined);
                } catch (error) {
                    isPreparingCartSubmit = false;
                    console.error(error);
                    removeLineItemProperty("Cutout image upload");
                    removeLineItemProperty("3D model image upload");
                    setStatus(error?.message || "Upload failed. Please try again.");
                }
            }, { capture: true });
        }

        const lineItemProperties = new Map();
        let productVariants = [];
        try {
            productVariants = variantDataNode ? JSON.parse(variantDataNode.textContent || "[]") : [];
        } catch (err) {
            console.warn("Product variants JSON could not be parsed.", err);
        }
        const selectedOptions = productVariants[0]?.options ? [...productVariants[0].options] : [];

        function setLineItemProperty(name, value) {
            if (!productForm) return;
            let input = lineItemProperties.get(name) || [...productForm.querySelectorAll('input[name^="properties["]')]
                .find((item) => item.name === `properties[${name}]`);
            if (!input) {
                input = document.createElement("input");
                input.type = "hidden";
                input.name = `properties[${name}]`;
                productForm.appendChild(input);
            }
            input.value = value || "";
            lineItemProperties.set(name, input);
        }

        function removeLineItemProperty(name) {
            if (!productForm) return;
            const input = lineItemProperties.get(name) || [...productForm.querySelectorAll('input[name^="properties["]')]
                .find((item) => item.name === `properties[${name}]`);
            if (!input) return;
            input.remove();
            lineItemProperties.delete(name);
        }

        let THREE = null;
        let scene, camera, renderer, controls;
        let pillowGroup = null;
        let frontMesh = null;
        let backMesh = null;
        let pillowTexture = null;
        let pillowMaterial = null;
        let contourFabricTexture = null;
        let sideMesh = null;
        let contourCurveMaterial = null;
        let contourCurveOverlayMaterial = null;
        let contourCurveGuide = null;
        let contourCurveOverlayGuide = null;
        let contourCurveBridgeGuide = null;
        let contourCurveReverseGuide = null;
        let contourCurveReverseOverlayGuide = null;
        let contourCurveWireGuideA = null;
        let contourCurveWireGuideB = null;
        let contourCurveWireMaterial = null;

        let selectedFile = null;
        let selectedUrl = "";
        let pillowSurfaceAspect = 0.65;
        let selectedPillowColor = "#ffffff";
        let cachedCutoutBitmap = null;
        let currentRawCutoutCanvas = null;
        let currentCutoutCanvas = null;
        let currentModelCanvas = null;
        let uploadedCutoutUrl = "";
        let uploadedCutoutFilename = "";
        let uploadedModelUrl = "";
        let uploadedModelFilename = "";
        let uploadedOriginalUrl = "";
        let allowNativeCartSubmit = false;
        let isPreparingCartSubmit = false;
        const BACKGROUND_REMOVAL_API_URL = customizerRoot.dataset.backgroundRemovalApiUrl || "https://rmbg.woodbests.xyz/api/remove-background";
        const COS_PILLOW_UPLOAD_URL = customizerRoot.dataset.uploadApiUrl || "https://r2.woodbests.xyz/upload";
        const THREE_MODULE_URL = customizerRoot.dataset.threeUrl;
        const BG_REMOVAL_CACHE_DB = "song-3d-pillow-bg-removal";
        const BG_REMOVAL_CACHE_STORE = "cutouts";
        const BG_REMOVAL_CACHE_VERSION = 1;
        const BG_REMOVAL_CACHE_MAX_ENTRIES = 12;
        const BG_REMOVAL_CACHE_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
        const bgRemovalMemoryCache = new Map();
        const bgRemovalPendingRequests = new Map();
        const modelHistoryEntries = [];
        let activeHistoryKey = "";

        const PILLOW_CORNER_RADIUS_RATIO = 0.6;
        const PILLOW_CUTOUT_DEPTH = 0.18;
        const PILLOW_WRAP_MARGIN_SCALE = 1;
        const PILLOW_MODEL_HEIGHT = 3.2;
        const PILLOW_SURFACE_SEGMENTS = 80;
        const PILLOW_CONTOUR_POINT_COUNT = 50;
        const PILLOW_CONTOUR_OUTER_LINE_Z = 0;
        const PILLOW_CONTOUR_LINK_LINE_Z_OFFSET = 0;
        const PILLOW_CONTOUR_CURVE_OVERLAY_Z_OFFSET = 0.0005;
        const PILLOW_CONTOUR_CURVE_WIDTH = 0.8;
        const PILLOW_CONTOUR_CENTER_HEIGHT = 0.3;
        const PILLOW_CONTOUR_CURVE_SEGMENTS = 4;
        const PILLOW_TEXTURE_SCALE = 1;
        const PILLOW_SHOW_CURVE_WIREFRAME = false;
        const PILLOW_CAMERA_ORTHO_HEIGHT = 2.2;
        const MODEL_PREVIEW_IMAGE_SIZE = 220;
        const MODEL_UPLOAD_IMAGE_SIZE = 1200;
        const CUTOUT_UPLOAD_MIN_LONG_SIDE = 1200;
        const CUTOUT_UPLOAD_MAX_LONG_SIDE = 2200;
        const HIDDEN_MODEL_IMAGE_URL_KEY = "_3D model image URL";
        const AUTO_ROTATE_SPEED = 0.0035;
        const AUTO_ROTATE_IDLE_DELAY_MS = 1200;
        function setStatus(text, loading = false) {
            if (statusText) statusText.textContent = text;
            if (statusSpinner) statusSpinner.classList.toggle("hidden", !loading);
            if (stageLoadingText) stageLoadingText.textContent = text || "Generating 3D model...";
            if (loading) showStageLoading();
        }

        function showStageLoading() {
            if (!stageLoadingOverlay) return;
            stageLoadingOverlay.classList.add("is-active");
            stageLoadingOverlay.setAttribute("aria-hidden", "false");
        }

        function hideStageLoading() {
            if (!stageLoadingOverlay) return;
            stageLoadingOverlay.classList.remove("is-active");
            stageLoadingOverlay.setAttribute("aria-hidden", "true");
        }

        function showProgress(pct) {
            if (!progressWrap || !progressBar) {
                showStageLoading();
                return;
            }
            progressWrap.classList.remove("hidden");
            showStageLoading();
            const stageLoadingProgress = stageLoadingProgressBar?.parentElement;
            if (pct < 0) {
                progressBar.classList.add("indeterminate");
                progressBar.style.width = "30%";
                if (stageLoadingProgress) stageLoadingProgress.style.display = "none";
            } else {
                progressBar.classList.remove("indeterminate");
                const width = Math.min(100, pct) + "%";
                progressBar.style.width = width;
                if (stageLoadingProgress) stageLoadingProgress.style.display = "block";
                if (stageLoadingProgressBar) stageLoadingProgressBar.style.width = width;
            }
        }

        function hideProgress() {
            if (progressWrap) progressWrap.classList.add("hidden");
            if (progressBar) {
                progressBar.style.width = "0%";
                progressBar.classList.remove("indeterminate");
            }
            if (stageLoadingProgressBar) stageLoadingProgressBar.style.width = "0%";
            hideStageLoading();
        }

        function applySelectedPillowColor() {
            if (!THREE) return;
            const isBlack = selectedPillowColor.toLowerCase() === "#000000";
            const edgeColor = isBlack ? "#0b0b0b" : "#fbfbf7";
            const highlightColor = isBlack ? "#1c1c1c" : "#ffffff";

            if (pillowMaterial) {
                pillowMaterial.color.set(pillowMaterial.map ? "#ffffff" : selectedPillowColor);
                pillowMaterial.needsUpdate = true;
            }
            if (sideMesh?.material) {
                sideMesh.material.color.set(selectedPillowColor);
                sideMesh.material.needsUpdate = true;
            }
            if (contourCurveMaterial) {
                contourCurveMaterial.color.set(edgeColor);
                contourCurveMaterial.emissive?.set(edgeColor);
                contourCurveMaterial.needsUpdate = true;
            }
            if (contourCurveOverlayMaterial) {
                contourCurveOverlayMaterial.color.set(contourCurveOverlayMaterial.map ? "#ffffff" : highlightColor);
                contourCurveOverlayMaterial.needsUpdate = true;
            }
        }

        function updatePillowColorProperty() {
            setLineItemProperty("Pillow color", selectedPillowColor.toLowerCase() === "#000000" ? "Black" : "White");
        }

        function setPillowColor(color, { repaint = true, status = false } = {}) {
            selectedPillowColor = color || "#ffffff";
            const normalizedColor = selectedPillowColor.toLowerCase();
            colorSwatches.forEach((item) => {
                const active = (item.dataset.pillowColor || "").toLowerCase() === normalizedColor;
                item.classList.toggle("is-active", active);
            });
            updateCustomizerProperties();
            applySelectedPillowColor();

            if (repaint && repaintModelColorFromCache() && status) {
                setStatus("Color updated. Drag to rotate the 3D model.");
            }
        }

        function updateCustomizerProperties(extra = {}) {
            updatePillowColorProperty();
            setLineItemProperty("Cutout image URL", uploadedCutoutUrl || "");
            setLineItemProperty(HIDDEN_MODEL_IMAGE_URL_KEY, uploadedModelUrl || "");
            setLineItemProperty("Original image URL", uploadedOriginalUrl || "");
            removeLineItemProperty("3D model image URL");
            removeLineItemProperty("Custom image file");
            removeLineItemProperty("Cutout image filename");
            removeLineItemProperty("Cutout image upload");
            removeLineItemProperty("3D model image filename");
            removeLineItemProperty("3D model image upload");
            Object.entries(extra).forEach(([name, value]) => setLineItemProperty(name, value));
        }

        function syncLatestDesignForCart() {
            const previewImage = captureModelScreenshot();
            if (previewImage) {
                setLineItemProperty("Cutout image URL", uploadedCutoutUrl || "");
                setLineItemProperty("Original image URL", uploadedOriginalUrl || "");
                removeLineItemProperty("Cutout image filename");
                removeLineItemProperty("Cutout image upload");
                return;
            }

            updateCustomizerProperties();
        }

        function getSelectedVariantLabel(variant) {
            if (!variant) return "";
            const sizeOptionGroup = variantOptionsRoot?.querySelector(".variant-option--cards[data-option-index]");
            if (sizeOptionGroup) {
                const optionIndex = Number(sizeOptionGroup.dataset.optionIndex || 0);
                return selectedOptions[optionIndex] || variant.options?.[optionIndex] || variant.title || "";
            }
            return variant.title || "";
        }

        function setSubmitButtonState(variant) {
            if (!productSubmitButton) return;
            const unavailable = !variant || !variant.available;
            productSubmitButton.toggleAttribute("disabled", unavailable);
            productSubmitButton.setAttribute("aria-disabled", unavailable ? "true" : "false");
            if (productSubmitText) {
                productSubmitText.textContent = unavailable
                    ? (variant ? "Sold out" : "Unavailable")
                    : getCartButtonText(variant);
            }
        }

        function formatMoney(cents) {
            const value = Number(cents || 0) / 100;
            const fixed = value.toFixed(2);
            const noDecimals = Math.round(value).toString();
            const withComma = fixed.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            const noDecimalsWithComma = noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            return moneyFormatText
                .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimalsWithComma)
                .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
                .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, fixed.replace(".", ","))
                .replace(/\{\{\s*amount\s*\}\}/g, withComma);
        }

        function getCartButtonText(variant) {
            if (!variant) return cartButtonLabel || cartButtonPrefix;
            const price = Number(variant.price || 0);
            return `${cartButtonPrefix} ${formatMoney(price)}`;
        }

        function getVariantFeaturedImage(variant) {
            if (!variant) return "";

            const image = variant.featured_image || variant.image || variant.featured_media?.preview_image;
            if (!image) return "";
            if (typeof image === "string") return image;

            return image.src
                || image.url
                || image.preview_image?.src
                || "";
        }

        function syncVariantButtonImages() {
            if (!variantOptionsRoot || !productVariants.length) return;

            variantOptionsRoot.querySelectorAll("[data-option-index]").forEach((optionGroup) => {
                const optionIndex = Number(optionGroup.dataset.optionIndex || 0);
                optionGroup.querySelectorAll("[data-option-value]").forEach((button) => {
                    const testOptions = [...selectedOptions];
                    testOptions[optionIndex] = button.dataset.optionValue || "";
                    const variant = productVariants.find((item) =>
                        item.options.every((value, index) => value === testOptions[index])
                    );
                    const imageVariant = productVariants.find((item) =>
                        item.options[optionIndex] === button.dataset.optionValue && getVariantFeaturedImage(item)
                    );
                    const imageSrc = getVariantFeaturedImage(imageVariant) || getVariantFeaturedImage(variant) || button.dataset.variantImage || "";
                    if (!imageSrc) return;
                    button.dataset.variantImage = imageSrc;
                    const media = button.querySelector(".variant-option-card-media");
                    if (!media) return;

                    let cardImage = media.querySelector("img");
                    if (!cardImage) {
                        cardImage = document.createElement("img");
                        cardImage.alt = button.dataset.optionValue || "";
                        cardImage.loading = "lazy";
                        cardImage.width = 90;
                        cardImage.height = 90;
                        media.appendChild(cardImage);
                    }
                    cardImage.src = imageSrc;
                });
            });
        }

        function restoreSelectedOptions(options) {
            if (!Array.isArray(options) || !variantOptionsRoot) return;

            variantOptionsRoot.querySelectorAll("[data-option-index]").forEach((optionGroup) => {
                const optionIndex = Number(optionGroup.dataset.optionIndex || 0);
                const value = options[optionIndex];
                if (typeof value === "undefined") return;

                const buttons = [...optionGroup.querySelectorAll("[data-option-value]")];
                const selectedButton = buttons.find((button) => button.dataset.optionValue === value);
                if (!selectedButton) return;

                selectedOptions[optionIndex] = value;
                buttons.forEach((button) => {
                    const active = button === selectedButton;
                    button.classList.toggle("is-active", active);
                    button.setAttribute("aria-pressed", active ? "true" : "false");
                });
            });

            syncSelectedVariant();
        }

        function syncSelectedVariant() {
            if (!productVariants.length || !variantIdInput) return;
            const variant = productVariants.find((item) =>
                item.options.every((value, index) => value === selectedOptions[index])
            );

            if (variant) {
                variantIdInput.value = variant.id;
                variantIdInput.disabled = !variant.available;
                setLineItemProperty("Selected variant", getSelectedVariantLabel(variant));
            }
            setSubmitButtonState(variant);
            syncVariantButtonImages();
            refreshVariantOptionAvailability();
        }

        function refreshVariantOptionAvailability() {
            if (!variantOptionsRoot || !productVariants.length) return;

            variantOptionsRoot.querySelectorAll("[data-option-index]").forEach((optionGroup) => {
                const optionIndex = Number(optionGroup.dataset.optionIndex || 0);
                optionGroup.querySelectorAll("[data-option-value]").forEach((button) => {
                    const testOptions = [...selectedOptions];
                    testOptions[optionIndex] = button.dataset.optionValue || "";
                    const hasAvailableVariant = productVariants.some((variant) =>
                        variant.available && variant.options.every((value, index) => value === testOptions[index])
                    );
                    button.classList.toggle("is-disabled", !hasAvailableVariant);
                    button.toggleAttribute("aria-disabled", !hasAvailableVariant);
                });
            });
        }

        function initVariantOptions() {
            if (!productVariants.length) return;
            if (!variantOptionsRoot) {
                const variant = productVariants.find((item) => String(item.id) === String(variantIdInput?.value))
                    || productVariants[0];
                setSubmitButtonState(variant);
                syncVariantButtonImages();
                return;
            }

            variantOptionsRoot.querySelectorAll("[data-option-index]").forEach((optionGroup) => {
                const optionIndex = Number(optionGroup.dataset.optionIndex || 0);
                const activeButton = optionGroup.querySelector("[data-option-value].is-active")
                    || optionGroup.querySelector("[data-option-value]");
                if (activeButton) selectedOptions[optionIndex] = activeButton.dataset.optionValue || "";

                optionGroup.querySelectorAll("[data-option-value]").forEach((button) => {
                    button.addEventListener("click", () => {
                        selectedOptions[optionIndex] = button.dataset.optionValue || "";
                        optionGroup.querySelectorAll("[data-option-value]").forEach((item) => {
                            const active = item === button;
                            item.classList.toggle("is-active", active);
                            item.setAttribute("aria-pressed", active ? "true" : "false");
                        });
                        syncSelectedVariant();
                        updateStageModelPreviewSize();
                    });
                });
            });

            syncSelectedVariant();
        }

        function setStageVisible(visible) {
            if (!stage3d) return;
            stage3d.classList.toggle("hidden-stage", !visible);
            if (visible && renderer && camera) {
                resize3D();
                renderer.render(scene, camera);
            }
        }

        function setModelVisible(visible) {
            if (pillowGroup) pillowGroup.visible = visible;
        }

        function resetCameraToFront() {
            if (!camera) return;
            camera.position.set(0, 0.3, 5.2);
            camera.lookAt(0, 0, 0);
            if (controls) {
                controls.target.set(0, 0, 0);
                controls.update();
            }
        }

        function createLocalModelControls(element) {
            const target = new THREE.Vector3(0, 0, 0);
            let pointerDown = false;
            let lastX = 0;
            let lastY = 0;
            let rotationVelocity = 0;
            let lastInteractionAt = 0;

            const markInteraction = () => {
                lastInteractionAt = performance.now();
            };

            const rotateModel = (deltaX, deltaY = 0) => {
                if (!pillowGroup) return;
                pillowGroup.rotation.y += deltaX * 0.01;
                pillowGroup.rotation.x = Math.max(-0.42, Math.min(0.42, pillowGroup.rotation.x + deltaY * 0.006));
            };

            element.addEventListener("pointerdown", (event) => {
                pointerDown = true;
                lastX = event.clientX;
                lastY = event.clientY;
                rotationVelocity = 0;
                markInteraction();
                element.setPointerCapture?.(event.pointerId);
            });

            element.addEventListener("pointermove", (event) => {
                if (!pointerDown) return;
                const deltaX = event.clientX - lastX;
                const deltaY = event.clientY - lastY;
                lastX = event.clientX;
                lastY = event.clientY;
                rotationVelocity = deltaX * 0.01;
                markInteraction();
                rotateModel(deltaX, deltaY);
            });

            const stopPointer = (event) => {
                pointerDown = false;
                markInteraction();
                element.releasePointerCapture?.(event.pointerId);
            };

            element.addEventListener("pointerup", stopPointer);
            element.addEventListener("pointercancel", stopPointer);
            element.addEventListener("wheel", (event) => {
                event.preventDefault();
                if (!camera?.isOrthographicCamera) return;
                markInteraction();
                camera.zoom = Math.max(0.55, Math.min(1, camera.zoom - event.deltaY * 0.0008));
                camera.updateProjectionMatrix();
            }, { passive: false });

            return {
                target,
                update() {
                    if (!pointerDown && pillowGroup) {
                        if (Math.abs(rotationVelocity) > 0.0005) {
                            pillowGroup.rotation.y += rotationVelocity;
                            rotationVelocity *= 0.92;
                        } else {
                            rotationVelocity = 0;
                            if (autoRotateEnabled && performance.now() - lastInteractionAt > AUTO_ROTATE_IDLE_DELAY_MS) {
                                pillowGroup.rotation.y += AUTO_ROTATE_SPEED;
                            }
                        }
                    }
                    camera?.lookAt(target);
                }
            };
        }

        function playModelEnterAnimation(onComplete) {
            if (!pillowGroup) return;
            const targetScale = pillowGroup.scale.clone();
            const targetRotationY = 0;
            pillowGroup.rotation.set(0, 0, 0);
            pillowGroup.visible = true;
            pillowGroup.scale.copy(targetScale).multiplyScalar(0.72);
            pillowGroup.rotation.y = Math.PI * 2;

            const start = performance.now();
            const duration = 2200;
            const startScale = 0.72;

            function step(now) {
                if (!pillowGroup) return;
                const t = Math.min(1, (now - start) / duration);
                const eased = 1 - Math.pow(1 - t, 3);
                const scale = startScale + (1 - startScale) * eased;
                pillowGroup.scale.copy(targetScale).multiplyScalar(scale);
                pillowGroup.rotation.y = targetRotationY + Math.PI * 2 * (1 - eased);
                if (t < 1) requestAnimationFrame(step);
                else {
                    pillowGroup.rotation.y = targetRotationY;
                    if (typeof onComplete === "function") onComplete();
                }
            }

            requestAnimationFrame(step);
        }

        function presentBuiltModel(onComplete) {
            setModelVisible(false);
            if (frontMesh) frontMesh.visible = false;
            if (backMesh) backMesh.visible = false;
            if (sideMesh) sideMesh.visible = false;
            setStageVisible(true);
            setDropHintCompactState(true);
            resetCameraToFront();
            resize3D();
            playModelEnterAnimation(onComplete);
        }

        function captureModelScreenshot() {
            if (!renderer || !scene || !camera || !pillowGroup || !pillowGroup.visible) return "";
            renderer.render(scene, camera);

            const source = renderer.domElement;
            const thumb = document.createElement("canvas");
            const size = 220;
            thumb.width = size;
            thumb.height = size;
            const ctx = thumb.getContext("2d");
            ctx.fillStyle = "#d9c2f1";
            ctx.fillRect(0, 0, size, size);

            const scale = Math.min(size / source.width, size / source.height);
            const drawW = source.width * scale;
            const drawH = source.height * scale;
            ctx.drawImage(source, (size - drawW) * 0.5, (size - drawH) * 0.5, drawW, drawH);
            return thumb.toDataURL("image/png");
        }

        function captureTransparentModelImage(size = MODEL_PREVIEW_IMAGE_SIZE) {
            if (!renderer || !scene || !camera || !pillowGroup || !pillowGroup.visible) return "";

            const previousPosition = camera.position.clone();
            const previousQuaternion = camera.quaternion.clone();
            const previousTarget = controls?.target ? controls.target.clone() : null;

            camera.position.set(0, 0.3, 5.2);
            camera.lookAt(0, 0, 0);
            camera.updateProjectionMatrix();
            camera.updateMatrixWorld();
            if (controls?.target) {
                controls.target.set(0, 0, 0);
                controls.update();
            }

            renderer.render(scene, camera);

            const source = renderer.domElement;
            const cropped = document.createElement("canvas");
            cropped.width = source.width;
            cropped.height = source.height;
            const croppedCtx = cropped.getContext("2d");
            croppedCtx.clearRect(0, 0, cropped.width, cropped.height);
            croppedCtx.drawImage(source, 0, 0);
            cropCanvasToAlphaBounds(cropped, 8);
            if (cropped.width < 2 || cropped.height < 2) return "";

            const thumb = document.createElement("canvas");
            thumb.width = size;
            thumb.height = size;
            const thumbCtx = thumb.getContext("2d");
            thumbCtx.clearRect(0, 0, size, size);

            const inset = 8;
            const targetSize = size - inset * 2;
            const scale = Math.min(targetSize / cropped.width, targetSize / cropped.height);
            const drawW = cropped.width * scale;
            const drawH = cropped.height * scale;
            thumbCtx.drawImage(cropped, (size - drawW) * 0.5, (size - drawH) * 0.5, drawW, drawH);

            camera.position.copy(previousPosition);
            camera.quaternion.copy(previousQuaternion);
            camera.updateProjectionMatrix();
            camera.updateMatrixWorld();
            if (controls && previousTarget) {
                controls.target.copy(previousTarget);
                controls.update();
            }
            renderer.render(scene, camera);

            return thumb.toDataURL("image/png");
        }

        function resize3D() {
            if (!stage3d || !camera) return;
            const w = stage3d.clientWidth || 1;
            const h = stage3d.clientHeight || 1;
            const aspect = w / h;
            if (camera.isOrthographicCamera) {
                const groupScaleX = pillowGroup ? Math.abs(pillowGroup.scale.x || 1) : 1;
                const modelW = PILLOW_MODEL_HEIGHT * pillowSurfaceAspect * groupScaleX + 0.9;
                const modelH = PILLOW_MODEL_HEIGHT + 0.9;
                const fitHeight = Math.max(PILLOW_CAMERA_ORTHO_HEIGHT, modelH, modelW / Math.max(0.2, aspect)) * 1.08;
                const halfH = fitHeight * 0.5;
                const halfW = halfH * aspect;
                camera.left = -halfW;
                camera.right = halfW;
                camera.top = halfH;
                camera.bottom = -halfH;
            } else {
                camera.aspect = aspect;
            }
            camera.updateProjectionMatrix();
            renderer.setSize(w, h);
        }

        function renderLoop() {
            requestAnimationFrame(renderLoop);
            if (controls) controls.update();
            renderer.render(scene, camera);
        }

        function showAllContourCurveLayers() {
            if (contourCurveGuide) contourCurveGuide.visible = true;
            if (contourCurveOverlayGuide) contourCurveOverlayGuide.visible = true;
            if (contourCurveBridgeGuide) contourCurveBridgeGuide.visible = true;
            if (contourCurveReverseGuide) contourCurveReverseGuide.visible = true;
            if (contourCurveReverseOverlayGuide) contourCurveReverseOverlayGuide.visible = true;
            if (contourCurveWireGuideA) contourCurveWireGuideA.visible = PILLOW_SHOW_CURVE_WIREFRAME;
            if (contourCurveWireGuideB) contourCurveWireGuideB.visible = PILLOW_SHOW_CURVE_WIREFRAME;
        }


        function remapUVToGeometryBounds(geometry) {
            geometry.computeBoundingBox();
            const box = geometry.boundingBox;
            const sizeX = Math.max(box.max.x - box.min.x, 1e-6);
            const sizeY = Math.max(box.max.y - box.min.y, 1e-6);
            const pos = geometry.attributes.position;
            const uv = new Float32Array(pos.count * 2);
            for (let i = 0; i < pos.count; i++) {
                uv[i * 2]     = (pos.getX(i) - box.min.x) / sizeX;
                uv[i * 2 + 1] = (pos.getY(i) - box.min.y) / sizeY;
            }
            geometry.setAttribute("uv", new THREE.BufferAttribute(uv, 2));
        }

        function arcProfile(t) {
            const c = Math.max(0, Math.min(1, t));
            return Math.pow(Math.min(1, c * 3), 0.5);
        }

        function smoothstep01(t) {
            const c = Math.max(0, Math.min(1, t));
            return c * c * (3 - 2 * c);
        }

        function smoothstepRange(edge0, edge1, x) {
            if (edge1 <= edge0) return x >= edge1 ? 1 : 0;
            return smoothstep01((x - edge0) / (edge1 - edge0));
        }

        function createRoundedRectShape(halfW, halfH, radius) {
            const shape = new THREE.Shape();
            const r = Math.min(radius, halfW * 0.45, halfH * 0.45);
            shape.moveTo(-halfW + r, -halfH);
            shape.lineTo(halfW - r, -halfH);
            shape.quadraticCurveTo(halfW, -halfH, halfW, -halfH + r);
            shape.lineTo(halfW, halfH - r);
            shape.quadraticCurveTo(halfW, halfH, halfW - r, halfH);
            shape.lineTo(-halfW + r, halfH);
            shape.quadraticCurveTo(-halfW, halfH, -halfW, halfH - r);
            shape.lineTo(-halfW, -halfH + r);
            shape.quadraticCurveTo(-halfW, -halfH, -halfW + r, -halfH);
            return shape;
        }

        function normalizeOutlineDirection(points) {
            let area = 0;
            for (let i = 0; i < points.length; i++) {
                const c = points[i];
                const n = points[(i + 1) % points.length];
                area += c.x * n.y - n.x * c.y;
            }
            return area < 0 ? [...points].reverse() : points;
        }

        function createSideWallGeometry(outlinePoints, depth, options = {}) {
            const halfDepth = depth * 0.5;
            const points = normalizeOutlineDirection(outlinePoints);
            const n = points.length;
            const roundSegments = options.roundSegments ?? 10;
            const roundBulge = options.roundBulge ?? 0.075;
            const xScaleBase = options.xScale ?? 0;
            const yScaleBase = options.yScale ?? 0;
            const ringCount = roundSegments + 1;
            const positions = [];
            const normals = [];
            const uvs = [];
            const indices = [];

            for (let i = 0; i < n; i++) {
                const p = points[i];
                const next = points[(i + 1) % n];
                const prev = points[(i - 1 + n) % n];
                const dx = next.x - prev.x;
                const dy = next.y - prev.y;
                const len = Math.max(1e-6, Math.sqrt(dx * dx + dy * dy));
                const nx = dy / len;
                const ny = -dx / len;

                for (let j = 0; j <= roundSegments; j++) {
                    const v = j / roundSegments;
                    const round = Math.sin(Math.PI * v);
                    const xScale = 1 - (1 - xScaleBase) * round;
                    const yScale = 1 - (1 - yScaleBase) * round;
                    const z = halfDepth * (1 - v * 2);
                    positions.push(
                        (p.x + nx * roundBulge * round) * xScale,
                        (p.y + ny * roundBulge * round) * yScale,
                        z
                    );

                    const zNormal = Math.cos(Math.PI * v);
                    normals.push(nx * round, ny * round, zNormal);
                    uvs.push(i / n, v);
                }
            }

            for (let i = 0; i < n; i++) {
                const nextI = (i + 1) % n;
                for (let j = 0; j < roundSegments; j++) {
                    const a = i * ringCount + j;
                    const b = i * ringCount + j + 1;
                    const c = nextI * ringCount + j;
                    const d = nextI * ringCount + j + 1;
                    indices.push(a, b, c);
                    indices.push(b, d, c);
                }
            }

            const geo = new THREE.BufferGeometry();
            geo.setAttribute("position", new THREE.Float32BufferAttribute(positions, 3));
            geo.setAttribute("normal", new THREE.Float32BufferAttribute(normals, 3));
            geo.setAttribute("uv", new THREE.Float32BufferAttribute(uvs, 2));
            geo.setIndex(indices);
            return geo;
        }

        function getOutlineCenter(points) {
            const center = points.reduce((sum, p) => {
                sum.x += p.x;
                sum.y += p.y;
                return sum;
            }, { x: 0, y: 0 });
            center.x /= points.length;
            center.y /= points.length;
            return center;
        }

        function getContourFabricTexture() {
            if (contourFabricTexture || !THREE) return contourFabricTexture;

            const canvas = document.createElement("canvas");
            canvas.width = 128;
            canvas.height = 128;
            const ctx = canvas.getContext("2d");
            ctx.fillStyle = "#f6f1e8";
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            for (let i = 0; i < 128; i += 4) {
                ctx.fillStyle = i % 8 === 0 ? "rgba(214,205,190,0.34)" : "rgba(255,255,255,0.28)";
                ctx.fillRect(i, 0, 1, 128);
                ctx.fillRect(0, i, 128, 1);
            }

            for (let y = 0; y < 128; y += 2) {
                for (let x = (y % 4); x < 128; x += 8) {
                    ctx.fillStyle = "rgba(178,166,145,0.12)";
                    ctx.fillRect(x, y, 2, 1);
                }
            }

            contourFabricTexture = new THREE.CanvasTexture(canvas);
            contourFabricTexture.colorSpace = THREE.SRGBColorSpace;
            contourFabricTexture.wrapS = THREE.RepeatWrapping;
            contourFabricTexture.wrapT = THREE.RepeatWrapping;
            contourFabricTexture.repeat.set(7, 7);
            contourFabricTexture.anisotropy = renderer ? Math.min(4, renderer.capabilities.getMaxAnisotropy()) : 1;
            contourFabricTexture.needsUpdate = true;
            return contourFabricTexture;
        }

        function createContourArcGeometry(outlinePoints, zDirectionSign = 1) {
            const points = normalizeOutlineDirection(outlinePoints);
            if (!points || points.length < 3) return new THREE.BufferGeometry();

            const center = getOutlineCenter(points);
            const segmentCount = points.length;
            const ringCount = Math.max(3, PILLOW_CONTOUR_CURVE_SEGMENTS + 1);
            const positions = [];
            const uvs = [];
            const indices = [];
            const outerZ = PILLOW_CONTOUR_OUTER_LINE_Z + PILLOW_CONTOUR_LINK_LINE_Z_OFFSET;
            const centerZ = PILLOW_CONTOUR_CENTER_HEIGHT + PILLOW_CONTOUR_LINK_LINE_Z_OFFSET;
            const signedOuterZ = zDirectionSign * outerZ;
            const signedCenterZ = zDirectionSign * centerZ;
            const curveWidth = PILLOW_CONTOUR_CURVE_WIDTH;

            for (let r = 0; r < ringCount; r++) {
                const t = ringCount <= 0 ? 0 : r / ringCount;
                const theta = t * Math.PI * 0.5;
                const widthOffset = curveWidth * (1 - Math.cos(theta));
                const z = signedOuterZ + (signedCenterZ - signedOuterZ) * Math.sin(theta);

                for (let s = 0; s < segmentCount; s++) {
                    const outer = points[s];
                    const dirX = center.x - outer.x;
                    const dirY = center.y - outer.y;
                    const dirLen = Math.max(1e-6, Math.hypot(dirX, dirY));
                    positions.push(
                        outer.x + dirX / dirLen * widthOffset,
                        outer.y + dirY / dirLen * widthOffset,
                        z
                    );
                    const u = s / Math.max(1, segmentCount - 1);
                    uvs.push(zDirectionSign >= 0 ? u : 1 - u, t);
                }
            }

            for (let r = 0; r < ringCount - 1; r++) {
                const ringOffset = r * segmentCount;
                const nextRingOffset = (r + 1) * segmentCount;
                for (let s = 0; s < segmentCount; s++) {
                    const next = (s + 1) % segmentCount;
                    const a = ringOffset + s;
                    const b = ringOffset + next;
                    const c = nextRingOffset + s;
                    const d = nextRingOffset + next;
                    if (zDirectionSign >= 0) {
                        indices.push(a, b, c);
                        indices.push(b, d, c);
                    } else {
                        indices.push(a, c, b);
                        indices.push(b, c, d);
                    }
                }
            }

            const centerIndex = positions.length / 3;
            positions.push(center.x, center.y, signedCenterZ);
            uvs.push(0.5, 1);

            const lastRingOffset = (ringCount - 1) * segmentCount;
            for (let s = 0; s < segmentCount; s++) {
                const next = (s + 1) % segmentCount;
                const a = lastRingOffset + s;
                const b = lastRingOffset + next;
                if (zDirectionSign >= 0) {
                    indices.push(a, b, centerIndex);
                } else {
                    indices.push(a, centerIndex, b);
                }
            }

            const geometry = new THREE.BufferGeometry();
            geometry.setAttribute("position", new THREE.Float32BufferAttribute(positions, 3));
            geometry.setAttribute("uv", new THREE.Float32BufferAttribute(uvs, 2));
            geometry.setIndex(indices);
            remapUVToGeometryBounds(geometry);
            geometry.computeVertexNormals();
            return geometry;
        }

        function createContourCurveBridgeGeometry(outlinePoints) {
            const points = normalizeOutlineDirection(outlinePoints);
            if (!points || points.length < 3) return new THREE.BufferGeometry();

            const positions = [];
            const uvs = [];
            const indices = [];
            const bridgeZ = PILLOW_CONTOUR_OUTER_LINE_Z
                + PILLOW_CONTOUR_LINK_LINE_Z_OFFSET
                + PILLOW_CONTOUR_CURVE_OVERLAY_Z_OFFSET;

            for (let i = 0; i < points.length; i++) {
                const p = points[i];
                const u = i / Math.max(1, points.length - 1);
                positions.push(p.x, p.y, bridgeZ);
                positions.push(p.x, p.y, -bridgeZ);
                uvs.push(u, 1, u, 0);
            }

            for (let i = 0; i < points.length; i++) {
                const next = (i + 1) % points.length;
                const a = i * 2;
                const b = next * 2;
                const c = i * 2 + 1;
                const d = next * 2 + 1;
                indices.push(a, c, b);
                indices.push(b, c, d);
            }

            const geometry = new THREE.BufferGeometry();
            geometry.setAttribute("position", new THREE.Float32BufferAttribute(positions, 3));
            geometry.setAttribute("uv", new THREE.Float32BufferAttribute(uvs, 2));
            geometry.setIndex(indices);
            geometry.computeVertexNormals();
            return geometry;
        }

        function rebuildContourCurveGuide(outlinePoints) {
            if (!THREE || !pillowGroup || !outlinePoints || outlinePoints.length < 3) return;
            if (!contourCurveMaterial) {
                contourCurveMaterial = new THREE.MeshStandardMaterial({
                    color: "#f6f1e8",
                    transparent: false,
                    roughness: 1,
                    metalness: 0,
                    emissive: "#f6f1e8",
                    emissiveIntensity: 0.005,
                    toneMapped: false,
                    depthTest: true,
                    depthWrite: true,
                    side: THREE.DoubleSide,
                    bumpScale: 0.012
                });
            }
            if (!contourCurveOverlayMaterial) {
                contourCurveOverlayMaterial = new THREE.MeshStandardMaterial({
                    color: "#ffffff",
                    transparent: false,
                    alphaTest: 0,
                    roughness: 0.92,
                    metalness: 0,
                    toneMapped: false,
                    depthTest: true,
                    depthWrite: true,
                    side: THREE.DoubleSide,
                    polygonOffset: true,
                    polygonOffsetFactor: -1,
                    polygonOffsetUnits: -1
                });
            }
            if (!contourCurveWireMaterial) {
                contourCurveWireMaterial = new THREE.LineBasicMaterial({
                    color: 0x2563eb,
                    transparent: true,
                    opacity: 0.55,
                    depthTest: false,
                    depthWrite: false
                });
            }
            const fabricTexture = getContourFabricTexture();
            contourCurveMaterial.map = fabricTexture;
            contourCurveMaterial.bumpMap = fabricTexture;
            contourCurveMaterial.color.set("#f6f1e8");
            contourCurveMaterial.emissive.set("#f6f1e8");
            contourCurveMaterial.emissiveIntensity = 0.025;
            contourCurveMaterial.transparent = false;
            contourCurveMaterial.roughness = 1;
            contourCurveMaterial.depthWrite = true;
            contourCurveMaterial.needsUpdate = true;
            contourCurveOverlayMaterial.map = null;
            contourCurveOverlayMaterial.color.set("#ffffff");
            contourCurveOverlayMaterial.transparent = false;
            contourCurveOverlayMaterial.alphaTest = 0;
            contourCurveOverlayMaterial.depthWrite = true;
            contourCurveOverlayMaterial.needsUpdate = true;

            contourCurveGuide = new THREE.Mesh(createContourArcGeometry(outlinePoints, 1), contourCurveMaterial);
            contourCurveGuide.name = "pillowContourCurveGuideA";
            contourCurveGuide.renderOrder = 15;

            contourCurveOverlayGuide = new THREE.Mesh(createContourArcGeometry(outlinePoints, 1), contourCurveOverlayMaterial);
            contourCurveOverlayGuide.name = "pillowContourCurveGuideAOverlay";
            contourCurveOverlayGuide.position.z += PILLOW_CONTOUR_CURVE_OVERLAY_Z_OFFSET;
            contourCurveOverlayGuide.renderOrder = 16;

            contourCurveBridgeGuide = new THREE.Mesh(createContourCurveBridgeGeometry(outlinePoints), contourCurveMaterial);
            contourCurveBridgeGuide.name = "pillowContourCurveBridgeGuide";
            contourCurveBridgeGuide.renderOrder = 12;

            contourCurveReverseGuide = new THREE.Mesh(createContourArcGeometry(outlinePoints, -1), contourCurveMaterial);
            contourCurveReverseGuide.name = "pillowContourCurveGuideB";
            contourCurveReverseGuide.renderOrder = 13;

            contourCurveReverseOverlayGuide = new THREE.Mesh(createContourArcGeometry(outlinePoints, -1), contourCurveOverlayMaterial);
            contourCurveReverseOverlayGuide.name = "pillowContourCurveGuideBOverlay";
            contourCurveReverseOverlayGuide.position.z -= PILLOW_CONTOUR_CURVE_OVERLAY_Z_OFFSET;
            contourCurveReverseOverlayGuide.renderOrder = 14;

            contourCurveWireGuideA = new THREE.LineSegments(
                new THREE.WireframeGeometry(contourCurveGuide.geometry),
                contourCurveWireMaterial
            );
            contourCurveWireGuideA.name = "pillowContourCurveWireA";
            contourCurveWireGuideA.position.z += PILLOW_CONTOUR_CURVE_OVERLAY_Z_OFFSET * 2;
            contourCurveWireGuideA.renderOrder = 40;
            contourCurveWireGuideA.visible = PILLOW_SHOW_CURVE_WIREFRAME;

            contourCurveWireGuideB = new THREE.LineSegments(
                new THREE.WireframeGeometry(contourCurveReverseGuide.geometry),
                contourCurveWireMaterial
            );
            contourCurveWireGuideB.name = "pillowContourCurveWireB";
            contourCurveWireGuideB.position.z -= PILLOW_CONTOUR_CURVE_OVERLAY_Z_OFFSET * 2;
            contourCurveWireGuideB.renderOrder = 40;
            contourCurveWireGuideB.visible = PILLOW_SHOW_CURVE_WIREFRAME;

            pillowGroup.add(contourCurveGuide);
            pillowGroup.add(contourCurveOverlayGuide);
            pillowGroup.add(contourCurveBridgeGuide);
            pillowGroup.add(contourCurveReverseGuide);
            pillowGroup.add(contourCurveReverseOverlayGuide);
            pillowGroup.add(contourCurveWireGuideA);
            pillowGroup.add(contourCurveWireGuideB);
            applySelectedPillowColor();
            showAllContourCurveLayers();
        }

        function disposeContourRim() {
            if (contourCurveGuide) {
                contourCurveGuide.traverse(node => {
                    if (node !== contourCurveGuide && node.geometry) node.geometry.dispose();
                });
                if (contourCurveGuide.geometry) contourCurveGuide.geometry.dispose();
                if (contourCurveGuide.parent) contourCurveGuide.parent.remove(contourCurveGuide);
                contourCurveGuide = null;
            }
            if (contourCurveOverlayGuide) {
                if (contourCurveOverlayGuide.geometry) contourCurveOverlayGuide.geometry.dispose();
                if (contourCurveOverlayGuide.parent) contourCurveOverlayGuide.parent.remove(contourCurveOverlayGuide);
                contourCurveOverlayGuide = null;
            }
            if (contourCurveBridgeGuide) {
                if (contourCurveBridgeGuide.geometry) contourCurveBridgeGuide.geometry.dispose();
                if (contourCurveBridgeGuide.parent) contourCurveBridgeGuide.parent.remove(contourCurveBridgeGuide);
                contourCurveBridgeGuide = null;
            }
            if (contourCurveReverseGuide) {
                contourCurveReverseGuide.traverse(node => {
                    if (node !== contourCurveReverseGuide && node.geometry) node.geometry.dispose();
                });
                if (contourCurveReverseGuide.geometry) contourCurveReverseGuide.geometry.dispose();
                if (contourCurveReverseGuide.parent) contourCurveReverseGuide.parent.remove(contourCurveReverseGuide);
                contourCurveReverseGuide = null;
            }
            if (contourCurveReverseOverlayGuide) {
                if (contourCurveReverseOverlayGuide.geometry) contourCurveReverseOverlayGuide.geometry.dispose();
                if (contourCurveReverseOverlayGuide.parent) contourCurveReverseOverlayGuide.parent.remove(contourCurveReverseOverlayGuide);
                contourCurveReverseOverlayGuide = null;
            }
            if (contourCurveWireGuideA) {
                if (contourCurveWireGuideA.geometry) contourCurveWireGuideA.geometry.dispose();
                if (contourCurveWireGuideA.parent) contourCurveWireGuideA.parent.remove(contourCurveWireGuideA);
                contourCurveWireGuideA = null;
            }
            if (contourCurveWireGuideB) {
                if (contourCurveWireGuideB.geometry) contourCurveWireGuideB.geometry.dispose();
                if (contourCurveWireGuideB.parent) contourCurveWireGuideB.parent.remove(contourCurveWireGuideB);
                contourCurveWireGuideB = null;
            }
        }

        function rebuildContourRim(outlinePoints) {
            if (!THREE || !pillowGroup || !outlinePoints || outlinePoints.length < 3) return;

            disposeContourRim();
            rebuildContourCurveGuide(outlinePoints);
        }



        function disposePillow() {
            if (!scene) return;
            if (pillowGroup) {
                disposeContourRim();
                scene.remove(pillowGroup);
                pillowGroup.traverse(node => {
                    if (node.isMesh && node.geometry) node.geometry.dispose();
                    if (node.isMesh && node.material && node.material !== pillowMaterial) {
                        if (Array.isArray(node.material)) {
                            node.material.forEach(mt => mt && mt !== pillowMaterial && mt.dispose());
                        }
                        else node.material.dispose();
                    }
                });
                pillowGroup = null;
                frontMesh = null;
                backMesh = null;
                sideMesh = null;
            }
        }

        function buildPillowModel(aspectRatio = 0.65) {
            if (!THREE || !scene || !pillowMaterial) return;

            disposePillow();

            const safeAspect = Math.min(2.2, Math.max(0.3, aspectRatio || 0.65));
            pillowSurfaceAspect = safeAspect;

            const h = PILLOW_MODEL_HEIGHT;
            const w = h * safeAspect;

            const frontGeo = new THREE.PlaneGeometry(w, h, PILLOW_SURFACE_SEGMENTS, PILLOW_SURFACE_SEGMENTS);
            const backGeo  = new THREE.PlaneGeometry(w, h, PILLOW_SURFACE_SEGMENTS, PILLOW_SURFACE_SEGMENTS);
            remapUVToGeometryBounds(frontGeo);
            remapUVToGeometryBounds(backGeo);

            frontMesh = new THREE.Mesh(frontGeo, pillowMaterial);
            backMesh  = new THREE.Mesh(backGeo, pillowMaterial);
            frontMesh.position.z = PILLOW_CUTOUT_DEPTH * 0.5;
            backMesh.position.z  = -PILLOW_CUTOUT_DEPTH * 0.5;
            backMesh.rotation.y  = Math.PI;
            backMesh.scale.x     = -1;

            const halfW = w * 0.5;
            const halfH = h * 0.5;
            const edgeRadius = Math.min(halfW, halfH) * PILLOW_CORNER_RADIUS_RATIO;
            const sideShape = createRoundedRectShape(halfW, halfH, edgeRadius);
            const rawOutline = sideShape.getSpacedPoints(PILLOW_CONTOUR_POINT_COUNT);
            const outlinePoints = rawOutline.slice(0, -1);

            const sideGeo = createSideWallGeometry(outlinePoints, 0.2);
            const sideMaterial = new THREE.MeshStandardMaterial({
                color: selectedPillowColor,
                roughness: 0.95,
                metalness: 0,
                side: THREE.DoubleSide
            });
            sideMesh = new THREE.Mesh(sideGeo, sideMaterial);

            pillowGroup = new THREE.Group();
            pillowGroup.add(frontMesh);
            pillowGroup.add(backMesh);
            pillowGroup.add(sideMesh);
            scene.add(pillowGroup);
            rebuildContourRim(outlinePoints);
            applySelectedPillowColor();

        }


        function traceAlphaOutline(canvas, alphaThreshold = 16) {
            const srcW = canvas.width, srcH = canvas.height;
            if (srcW < 2 || srcH < 2) return null;

            const maxSide = 480;
            const scale = Math.max(1, Math.ceil(Math.max(srcW, srcH) / maxSide));
            const w = Math.max(2, Math.floor(srcW / scale));
            const h = Math.max(2, Math.floor(srcH / scale));

            const tmp = document.createElement("canvas");
            tmp.width = w; tmp.height = h;
            const tctx = tmp.getContext("2d");
            tctx.drawImage(canvas, 0, 0, w, h);
            const data = tctx.getImageData(0, 0, w, h).data;

            const mask = new Uint8Array(w * h);
            const idx = (x, y) => y * w + x;
            for (let y = 0; y < h; y++)
                for (let x = 0; x < w; x++)
                    mask[idx(x, y)] = data[(idx(x, y) * 4) + 3] >= alphaThreshold ? 1 : 0;

            let startX = -1, startY = -1;
            for (let y = 1; y < h - 1 && startX === -1; y++)
                for (let x = 1; x < w - 1; x++)
                    if (mask[idx(x, y)] && (
                        !mask[idx(x-1,y)] || !mask[idx(x+1,y)] ||
                        !mask[idx(x,y-1)] || !mask[idx(x,y+1)])) {
                        startX = x; startY = y; break;
                    }

            if (startX === -1) return null;

            const dirs = [[1,0],[1,1],[0,1],[-1,1],[-1,0],[-1,-1],[0,-1],[1,-1]];
            const boundary = [];
            let cx = startX, cy = startY, prevDir = 0;
            const maxSteps = w * h * 4;
            for (let step = 0; step < maxSteps; step++) {
                boundary.push([cx, cy]);
                let found = false;
                for (let k = 0; k < 8; k++) {
                    const d = (prevDir + k) % 8;
                    const nx = cx + dirs[d][0], ny = cy + dirs[d][1];
                    if (nx < 1 || ny < 1 || nx >= w-1 || ny >= h-1) continue;
                    if (!mask[idx(nx,ny)]) continue;
                    if (!(!mask[idx(nx-1,ny)] || !mask[idx(nx+1,ny)] ||
                          !mask[idx(nx,ny-1)] || !mask[idx(nx,ny+1)])) continue;
                    cx = nx; cy = ny; prevDir = (d + 6) % 8; found = true; break;
                }
                if (!found) break;
                if (cx === startX && cy === startY && boundary.length > 20) break;
            }

            if (boundary.length < 16) return null;

            const stride = Math.max(1, Math.floor(boundary.length / 120));
            const sampled = [];
            for (let i = 0; i < boundary.length; i += stride) sampled.push(boundary[i]);
            return { points: sampled, width: srcW, height: srcH, scaledW: w, scaledH: h };
        }

        function applyAlphaDrivenBulge(alphaCanvas, strength = 0.25, alphaThreshold = 10) {
            if (!THREE || !frontMesh || !backMesh || !alphaCanvas) return;

            const cw = alphaCanvas.width, ch = alphaCanvas.height;
            if (cw < 2 || ch < 2) return;

            const aCtx = alphaCanvas.getContext("2d");
            const img = aCtx.getImageData(0, 0, cw, ch).data;
            const outline = traceAlphaOutline(alphaCanvas, alphaThreshold);
            const outlinePoints = outline ? outline.points : [];
            const outScale = outline
                ? Math.max(outline.width / (outline.scaledW || outline.width),
                           outline.height / (outline.scaledH || outline.height))
                : 1;

            let minX = cw, minY = ch, maxX = 0, maxY = 0;
            for (let y = 0; y < ch; y += 8)
                for (let x = 0; x < cw; x++) {
                    if (img[((y * cw + x) * 4) + 3] >= alphaThreshold) {
                        minX = Math.min(minX, x); minY = Math.min(minY, y);
                        maxX = Math.max(maxX, x); maxY = Math.max(maxY, y);
                    }
                }
            const maxDist = Math.max(maxX - (minX+maxX)/2, maxY - (minY+maxY)/2, 0.01);

            const applyToMesh = (mesh, dir) => {
                const geo = mesh.geometry;
                const pos = geo.attributes.position;
                const uv  = geo.attributes.uv;
                if (!uv || !pos) return;

                if (!geo.userData.baseZ) {
                    geo.userData.baseZ = new Float32Array(pos.count);
                    for (let i = 0; i < pos.count; i++) geo.userData.baseZ[i] = pos.getZ(i);
                }
                const baseZ = geo.userData.baseZ;

                for (let i = 0; i < pos.count; i++) {
                    const u = uv.getX(i), v = uv.getY(i);
                    const px = Math.min(cw-1, Math.max(0, Math.round(u * (cw-1))));
                    const py = Math.min(ch-1, Math.max(0, Math.round((1-v) * (ch-1))));
                    const alpha = img[((py * cw + px) * 4) + 3] / 255;

                    if (alpha < 0.1) { pos.setZ(i, baseZ[i]); continue; }

                    let minDistSq = Infinity;
                    if (outlinePoints.length > 0) {
                        for (const pt of outlinePoints) {
                            const dx = px - pt[0] * outScale, dy = py - pt[1] * outScale;
                            const distSq = dx * dx + dy * dy;
                            if (distSq < minDistSq) minDistSq = distSq;
                        }
                    } else {
                        minDistSq = dx * dx + dy * dy;
                    }
                    const normalizedDist = Math.min(1, Math.sqrt(minDistSq) / maxDist);
                    const edgeFade = smoothstep01(normalizedDist / 0.34);
                    const edgeSink = 1 - smoothstepRange(0.13, 0.31, normalizedDist);
                    const roundedSink = edgeSink * edgeSink * (3 - 2 * edgeSink);
                    const thicknessPull = (PILLOW_CUTOUT_DEPTH * 0.5) * 0.56 * roundedSink;
                    const rimLift = 0;
                    const bulge = strength * arcProfile(normalizedDist) * edgeFade;
                    pos.setZ(i, baseZ[i] + dir * (bulge + rimLift - thicknessPull));
                }
                pos.needsUpdate = true;
                geo.computeVertexNormals();
            };

            applyToMesh(frontMesh, 1);
            applyToMesh(backMesh, 1);
        }


        function smoothOutlineToModelPoints(canvas, alphaThreshold, targetCount) {
            const outline = traceAlphaOutline(canvas, alphaThreshold);
            if (!outline || !outline.points || outline.points.length < 16) return null;

            const { points, width, height, scaledW, scaledH } = outline;
            const seamW = scaledW || width;
            const seamH = scaledH || height;
            const h = 3.2;
            const w = h * pillowSurfaceAspect;

            const modelPoints = points.map(p => new THREE.Vector3(
                ((p[0] / seamW) - 0.5) * w,
                (0.5 - (p[1] / seamH)) * h,
                0
            ));

            const curve = new THREE.CatmullRomCurve3(modelPoints, true, "catmullrom", 0.12);
            const resampled = curve.getPoints(targetCount);
            const points2D = smoothClosedOutlinePoints(resampled.map(p => ({ x: p.x, y: p.y })), 12);
            return { points2D };
        }

        function smoothClosedOutlinePoints(points, iterations = 4) {
            if (!points || points.length < 4) return points;
            let current = points.map(p => ({ x: p.x, y: p.y }));
            for (let pass = 0; pass < iterations; pass++) {
                current = current.map((p, i) => {
                    const prev = current[(i - 1 + current.length) % current.length];
                    const next = current[(i + 1) % current.length];
                    return {
                        x: p.x * 0.5 + (prev.x + next.x) * 0.25,
                        y: p.y * 0.5 + (prev.y + next.y) * 0.25
                    };
                });
            }
            return current;
        }

        function resampleClosedOutlinePoints(points, targetCount = 180) {
            if (!points || points.length < 4) return points || [];

            const lengths = [0];
            let total = 0;
            for (let i = 0; i < points.length; i++) {
                const a = points[i];
                const b = points[(i + 1) % points.length];
                total += Math.hypot(b.x - a.x, b.y - a.y);
                lengths.push(total);
            }
            if (total <= 0) return points.map(p => ({ x: p.x, y: p.y }));

            const resampled = [];
            for (let i = 0; i < targetCount; i++) {
                const d = (i / targetCount) * total;
                let seg = 0;
                while (seg < points.length - 1 && lengths[seg + 1] < d) seg++;

                const a = points[seg];
                const b = points[(seg + 1) % points.length];
                const span = Math.max(1e-6, lengths[seg + 1] - lengths[seg]);
                const t = (d - lengths[seg]) / span;
                resampled.push({
                    x: a.x + (b.x - a.x) * t,
                    y: a.y + (b.y - a.y) * t
                });
            }
            return resampled;
        }


        function createOpaqueWhiteTextureCanvas(sourceCanvas, fillColor = "#ffffff") {
            const canvas = document.createElement("canvas");
            canvas.width = sourceCanvas.width;
            canvas.height = sourceCanvas.height;
            const ctx = canvas.getContext("2d");
            ctx.fillStyle = fillColor;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(sourceCanvas, 0, 0);
            return canvas;
        }

        function applyPillowTexture(canvas) {
            if (!THREE || !renderer || !pillowMaterial) return;
            if (!canvas || canvas.width < 2 || canvas.height < 2) return;

            if (pillowTexture) pillowTexture.dispose();

            const maxAniso = Math.min(4, renderer.capabilities.getMaxAnisotropy());
            const textureCanvas = createOpaqueWhiteTextureCanvas(canvas, selectedPillowColor);
            const texture = new THREE.CanvasTexture(textureCanvas);
            texture.colorSpace     = THREE.SRGBColorSpace;
            texture.flipY          = true;
            texture.wrapS          = THREE.ClampToEdgeWrapping;
            texture.wrapT          = THREE.ClampToEdgeWrapping;
            const textureRepeat = 1 / Math.max(0.01, PILLOW_TEXTURE_SCALE);
            const textureOffset = (1 - textureRepeat) * 0.5;
            texture.repeat.set(textureRepeat, textureRepeat);
            texture.offset.set(textureOffset, textureOffset);
            texture.generateMipmaps = false;
            texture.minFilter      = THREE.LinearFilter;
            texture.magFilter      = THREE.LinearFilter;
            texture.premultiplyAlpha = false;
            texture.anisotropy     = maxAniso;
            texture.needsUpdate    = true;

            pillowTexture = texture;
            pillowMaterial.map        = pillowTexture;
            pillowMaterial.transparent = false;
            pillowMaterial.color.set("#fbfbf7");
            pillowMaterial.alphaMap   = null;
            pillowMaterial.alphaTest  = 0;
            pillowMaterial.toneMapped = false;
            pillowMaterial.needsUpdate = true;

            if (contourCurveMaterial) {
                const fabricTexture = getContourFabricTexture();
                contourCurveMaterial.map = fabricTexture;
                contourCurveMaterial.bumpMap = fabricTexture;
                contourCurveMaterial.color.set("#f6f1e8");
                contourCurveMaterial.emissive.set("#f6f1e8");
                contourCurveMaterial.emissiveIntensity = 0.025;
                contourCurveMaterial.transparent = false;
                contourCurveMaterial.roughness = 1;
                contourCurveMaterial.depthWrite = true;
                contourCurveMaterial.needsUpdate = true;
            }
            if (contourCurveOverlayMaterial) {
                contourCurveOverlayMaterial.map = pillowTexture;
                contourCurveOverlayMaterial.color.set("#ffffff");
                contourCurveOverlayMaterial.transparent = false;
                contourCurveOverlayMaterial.alphaTest = 0;
                contourCurveOverlayMaterial.depthWrite = true;
                contourCurveOverlayMaterial.needsUpdate = true;
            }

            if (pillowGroup) {
                const contentAspect = canvas.width / Math.max(1, canvas.height);
                pillowGroup.scale.x = contentAspect / Math.max(1e-6, pillowSurfaceAspect);
                pillowGroup.scale.y = 1;
                pillowGroup.scale.z = 1;
            }
            applySelectedPillowColor();
        }

        function binarizeAlpha(canvas, threshold = 128) {
            const w = canvas.width, h = canvas.height;
            if (w < 2 || h < 2) return;
            const ctx = canvas.getContext("2d");
            const imgData = ctx.getImageData(0, 0, w, h);
            const data = imgData.data;
            for (let i = 0; i < data.length; i += 4) {
                data[i + 3] = data[i + 3] > threshold ? 255 : 0;
            }
            ctx.putImageData(imgData, 0, 0);
        }

        function getAlphaBounds(canvas, threshold = 8) {
            const w = canvas.width, h = canvas.height;
            if (w < 2 || h < 2) return null;

            const ctx = canvas.getContext("2d");
            const data = ctx.getImageData(0, 0, w, h).data;
            let minX = w, minY = h, maxX = -1, maxY = -1;

            for (let y = 0; y < h; y++) {
                for (let x = 0; x < w; x++) {
                    if (data[((y * w + x) * 4) + 3] <= threshold) continue;
                    if (x < minX) minX = x;
                    if (y < minY) minY = y;
                    if (x > maxX) maxX = x;
                    if (y > maxY) maxY = y;
                }
            }

            if (maxX < minX || maxY < minY) return null;
            return { minX, minY, maxX, maxY, width: maxX - minX + 1, height: maxY - minY + 1 };
        }

        function cropCanvasToAlphaBounds(canvas, threshold = 8) {
            const bounds = getAlphaBounds(canvas, threshold);
            if (!bounds) return;

            const pad = Math.max(2, Math.round(Math.min(bounds.width, bounds.height) * 0.015));
            const sx = Math.max(0, bounds.minX - pad);
            const sy = Math.max(0, bounds.minY - pad);
            const sw = Math.min(canvas.width - sx, bounds.width + pad * 2);
            const sh = Math.min(canvas.height - sy, bounds.height + pad * 2);

            const cropped = document.createElement("canvas");
            cropped.width = sw;
            cropped.height = sh;
            cropped.getContext("2d").drawImage(canvas, sx, sy, sw, sh, 0, 0, sw, sh);

            canvas.width = sw;
            canvas.height = sh;
            canvas.getContext("2d").drawImage(cropped, 0, 0);
        }

        function cloneCanvas(sourceCanvas) {
            const canvas = document.createElement("canvas");
            canvas.width = sourceCanvas.width;
            canvas.height = sourceCanvas.height;
            canvas.getContext("2d").drawImage(sourceCanvas, 0, 0);
            return canvas;
        }

        function createModelCanvasFromCutout(sourceCanvas) {
            const canvas = cloneCanvas(sourceCanvas);
            cropCanvasToAlphaBounds(canvas, 8);
            return canvas;
        }

        function createSmoothOuterMask(sourceCanvas, alphaThreshold = 16) {
            const w = sourceCanvas.width, h = sourceCanvas.height;
            const mask = document.createElement("canvas");
            mask.width = w;
            mask.height = h;
            const ctx = mask.getContext("2d");

            const outline = traceAlphaOutline(sourceCanvas, alphaThreshold);
            if (!outline || !outline.points || outline.points.length < 16) {
                ctx.drawImage(sourceCanvas, 0, 0);
                ctx.globalCompositeOperation = "source-in";
                ctx.fillStyle = "#fff";
                ctx.fillRect(0, 0, w, h);
                ctx.globalCompositeOperation = "source-over";
                return mask;
            }

            const scaleX = outline.width / Math.max(1, outline.scaledW || outline.width);
            const scaleY = outline.height / Math.max(1, outline.scaledH || outline.height);
            const rawPoints = outline.points.map(p => ({ x: p[0] * scaleX, y: p[1] * scaleY }));
            const sampled = resampleClosedOutlinePoints(rawPoints, 180);
            const smoothPoints = smoothClosedOutlinePoints(sampled, 12);

            ctx.fillStyle = "#fff";
            const first = smoothPoints[0];
            const last = smoothPoints[smoothPoints.length - 1];
            ctx.beginPath();
            ctx.moveTo((last.x + first.x) * 0.5, (last.y + first.y) * 0.5);
            for (let i = 0; i < smoothPoints.length; i++) {
                const current = smoothPoints[i];
                const next = smoothPoints[(i + 1) % smoothPoints.length];
                const midX = (current.x + next.x) * 0.5;
                const midY = (current.y + next.y) * 0.5;
                ctx.quadraticCurveTo(current.x, current.y, midX, midY);
            }
            ctx.closePath();
            ctx.fill();
            return mask;
        }

        function roundedRectPath(ctx, x, y, w, h, r) {
            const radius = Math.max(0, Math.min(r, w * 0.5, h * 0.5));
            ctx.moveTo(x + radius, y);
            ctx.lineTo(x + w - radius, y);
            ctx.quadraticCurveTo(x + w, y, x + w, y + radius);
            ctx.lineTo(x + w, y + h - radius);
            ctx.quadraticCurveTo(x + w, y + h, x + w - radius, y + h);
            ctx.lineTo(x + radius, y + h);
            ctx.quadraticCurveTo(x, y + h, x, y + h - radius);
            ctx.lineTo(x, y + radius);
            ctx.quadraticCurveTo(x, y, x + radius, y);
        }

        function createCapsuleOuterMask(sourceCanvas, alphaThreshold = 16) {
            const w = sourceCanvas.width, h = sourceCanvas.height;
            const mask = document.createElement("canvas");
            mask.width = w;
            mask.height = h;
            const ctx = mask.getContext("2d");

            const bounds = getAlphaBounds(sourceCanvas, alphaThreshold);
            if (!bounds) {
                ctx.drawImage(sourceCanvas, 0, 0);
                ctx.globalCompositeOperation = "source-in";
                ctx.fillStyle = "#fff";
                ctx.fillRect(0, 0, w, h);
                ctx.globalCompositeOperation = "source-over";
                return mask;
            }

            const pad = Math.max(8, Math.round(Math.min(bounds.width, bounds.height) * 0.08));
            const x = Math.max(0, bounds.minX - pad);
            const y = Math.max(0, bounds.minY - pad);
            const shapeW = Math.min(w - x, bounds.width + pad * 2);
            const shapeH = Math.min(h - y, bounds.height + pad * 2);
            const radius = Math.min(shapeW, shapeH) * 0.5;

            ctx.beginPath();
            roundedRectPath(ctx, x, y, shapeW, shapeH, radius);
            ctx.closePath();
            ctx.fillStyle = "#fff";
            ctx.fill();
            return mask;
        }



        function addOutlineRing(sourceCanvas, outlinePx = 20) {
            const srcW = sourceCanvas.width, srcH = sourceCanvas.height;
            if (srcW < 2 || srcH < 2) return cloneCanvas(sourceCanvas);

            const r = Math.max(1, Math.round(outlinePx));
            const pad = r + 4;
            const w = srcW + pad * 2, h = srcH + pad * 2;

            // mask from alpha
            const mask = document.createElement("canvas");
            mask.width = w; mask.height = h;
            const mctx = mask.getContext("2d");
            mctx.drawImage(sourceCanvas, pad, pad);

            // expanded mask (outline ring area)
            const expanded = document.createElement("canvas");
            expanded.width = w; expanded.height = h;
            const ectx = expanded.getContext("2d");
            for (let y = -r; y <= r; y++) {
                for (let x = -r; x <= r; x++) {
                    if ((x * x) + (y * y) > r * r) continue;
                    ectx.drawImage(mask, x, y);
                }
            }

            // result canvas
            const result = document.createElement("canvas");
            result.width = w; result.height = h;
            const rctx = result.getContext("2d");

            // Step 1: draw white outline ring behind
            rctx.drawImage(expanded, 0, 0);
            rctx.globalCompositeOperation = "source-in";
            rctx.fillStyle = "#ffffff";
            rctx.fillRect(0, 0, w, h);
            rctx.globalCompositeOperation = "source-over";

            // Step 2: draw original image on top, unmodified
            rctx.drawImage(sourceCanvas, pad, pad);

            return result;
        }

        function createRawCutoutCanvas(source) {
            if (!source || source.width < 2 || source.height < 2) return null;
            const canvas = document.createElement("canvas");
            canvas.width = source.width;
            canvas.height = source.height;
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(source, 0, 0);
            return canvas;
        }

        function createColoredModelCanvasFromCache() {
            if (!cachedCutoutBitmap) return null;
            const rawCutoutCanvas = createRawCutoutCanvas(cachedCutoutBitmap);
            if (!rawCutoutCanvas) return null;
            const outlinedCanvas = addOutlineRing(rawCutoutCanvas, 0);
            return {
                cutoutCanvas: outlinedCanvas,
                modelCanvas: createModelCanvasFromCutout(outlinedCanvas)
            };
        }

        function rebuildModelFromCutoutCanvas(cutoutCanvas) {
            if (!cutoutCanvas) return null;
            const modelCanvas = createModelCanvasFromCutout(cutoutCanvas);
            currentModelCanvas = cloneCanvas(modelCanvas);
            updatePreviewCanvas(modelCanvas);
            buildPillowModel(modelCanvas.width / Math.max(1, modelCanvas.height));
            rebuildFrontBackFromCanvas(modelCanvas);
            applyAlphaDrivenBulge(modelCanvas, 0.32, 10);
            rebuildSideWallFromCanvas(modelCanvas);
            applyPillowTexture(modelCanvas);
            applySelectedPillowColor();

            return modelCanvas;
        }

        function repaintModelColorFromCache() {
            const rebuilt = createColoredModelCanvasFromCache();
            if (!rebuilt) return false;
            currentCutoutCanvas = cloneCanvas(rebuilt.cutoutCanvas);
            currentModelCanvas = cloneCanvas(rebuilt.modelCanvas);
            updatePreviewCanvas(rebuilt.modelCanvas);
            applyPillowTexture(rebuilt.modelCanvas);
            applySelectedPillowColor();
            window.requestAnimationFrame(() => {
                setModelPreviewState(captureTransparentModelImage());
            });
            return true;
        }

        function clearCachedCutout() {
            if (cachedCutoutBitmap?.close) cachedCutoutBitmap.close();
            cachedCutoutBitmap = null;
            currentRawCutoutCanvas = null;
        }

        function canvasToBlob(canvas, type = "image/png", quality) {
            return new Promise((resolve, reject) => {
                if (!canvas?.toBlob) {
                    reject(new Error("Canvas export is not supported in this browser."));
                    return;
                }
                canvas.toBlob((blob) => {
                    if (!blob) {
                        reject(new Error("Canvas export failed."));
                        return;
                    }
                    resolve(blob);
                }, type, quality);
            });
        }

        function resizeCanvasForUpload(canvas, minLongSide = 0, maxLongSide = Infinity) {
            if (!canvas || canvas.width < 2 || canvas.height < 2) return canvas;
            const longSide = Math.max(canvas.width, canvas.height);
            let targetLongSide = longSide;

            if (Number.isFinite(maxLongSide) && longSide > maxLongSide) {
                targetLongSide = maxLongSide;
            } else if (minLongSide && longSide < minLongSide) {
                targetLongSide = minLongSide;
            }

            if (targetLongSide === longSide) return canvas;

            const scale = targetLongSide / longSide;
            const resized = document.createElement("canvas");
            resized.width = Math.max(2, Math.round(canvas.width * scale));
            resized.height = Math.max(2, Math.round(canvas.height * scale));
            const ctx = resized.getContext("2d");
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = "high";
            ctx.drawImage(canvas, 0, 0, resized.width, resized.height);
            return resized;
        }

        async function uploadCutoutCanvas(canvas) {
            if (!canvas || canvas.width < 2 || canvas.height < 2) {
                throw new Error("Cutout canvas is empty.");
            }

            const exportCanvas = resizeCanvasForUpload(canvas, CUTOUT_UPLOAD_MIN_LONG_SIDE, CUTOUT_UPLOAD_MAX_LONG_SIDE);
            const blob = await canvasToBlob(exportCanvas, "image/png");
            if (blob.size > 10 * 1024 * 1024) {
                throw new Error("Cutout PNG exceeds the 10MB limit.");
            }

            const originalName = ((selectedFile?.name || "cutout").replace(/\.[^.]+$/, "") || "cutout")
                .replace(/[^a-z0-9_-]+/gi, "-")
                .replace(/^-+|-+$/g, "");
            const uploadFilename = `${originalName || "cutout"}-cutout.png`;
            const formData = new FormData();
            formData.append("file", blob, uploadFilename);

            const response = await fetch(COS_PILLOW_UPLOAD_URL, {
                method: "POST",
                body: formData
            });
            const responseText = await response.text().catch(() => "");
            let result = null;
            try {
                result = responseText ? JSON.parse(responseText) : null;
            } catch (error) {
                throw new Error(responseText || `Cutout upload returned HTTP ${response.status}.`);
            }

            if (!result || Number(result.code) !== 200 || !result.data?.url) {
                throw new Error(result?.msg || responseText || "Cutout upload failed.");
            }

            uploadedCutoutUrl = result.data.url;
            uploadedCutoutFilename = result.data.filename || uploadFilename;
            updateCustomizerProperties();

            return result.data.url;
        }

        async function uploadModelCanvas(canvas) {
            if (!canvas || canvas.width < 2 || canvas.height < 2) {
                throw new Error("Model canvas is empty.");
            }

            const exportCanvas = resizeCanvasForUpload(canvas, MODEL_UPLOAD_IMAGE_SIZE, MODEL_UPLOAD_IMAGE_SIZE);
            const blob = await canvasToBlob(exportCanvas, "image/png");
            if (blob.size > 10 * 1024 * 1024) {
                throw new Error("Model PNG exceeds the 10MB limit.");
            }

            const originalName = ((selectedFile?.name || "model").replace(/\.[^.]+$/, "") || "model")
                .replace(/[^a-z0-9_-]+/gi, "-")
                .replace(/^-+|-+$/g, "");
            const uploadFilename = `${originalName || "model"}-model.png`;
            const formData = new FormData();
            formData.append("file", blob, uploadFilename);

            const response = await fetch(COS_PILLOW_UPLOAD_URL, {
                method: "POST",
                body: formData
            });
            const responseText = await response.text().catch(() => "");
            let result = null;
            try {
                result = responseText ? JSON.parse(responseText) : null;
            } catch (error) {
                throw new Error(responseText || `Model upload returned HTTP ${response.status}.`);
            }

            if (!result || Number(result.code) !== 200 || !result.data?.url) {
                throw new Error(result?.msg || responseText || "Model upload failed.");
            }

            uploadedModelUrl = result.data.url;
            uploadedModelFilename = result.data.filename || uploadFilename;
            updateCustomizerProperties();

            return result.data.url;
        }

        async function uploadOriginalFile() {
            if (!selectedFile) return;

            const sanitized = (selectedFile.name || "original.png")
                .replace(/[^a-z0-9_.-]+/gi, "-")
                .replace(/^-+|-+$/g, "");
            const lastDot = sanitized.lastIndexOf(".");
            const baseName = lastDot > -1 ? sanitized.slice(0, lastDot) : sanitized;
            const ext = lastDot > -1 ? sanitized.slice(lastDot) : ".png";
            const uploadFilename = `${baseName}-original${ext}`;
            const formData = new FormData();
            formData.append("file", selectedFile, uploadFilename);

            const response = await fetch(COS_PILLOW_UPLOAD_URL, {
                method: "POST",
                body: formData
            });
            const responseText = await response.text().catch(() => "");
            let result = null;
            try {
                result = responseText ? JSON.parse(responseText) : null;
            } catch (error) {
                throw new Error(responseText || `Original image upload returned HTTP ${response.status}.`);
            }

            if (!result || Number(result.code) !== 200 || !result.data?.url) {
                throw new Error(result?.msg || responseText || "Original image upload failed.");
            }

            uploadedOriginalUrl = result.data.url;
            setLineItemProperty("Original image URL", uploadedOriginalUrl);
            return uploadedOriginalUrl;
        }


        function rebuildFrontBackFromCanvas(canvas) {
            if (!THREE || !pillowGroup || !pillowMaterial || !canvas) return;
            if (canvas.width < 2 || canvas.height < 2) return;

            const contentAspect = canvas.width / Math.max(1, canvas.height);
            const safeAspect = Math.min(2.2, Math.max(0.3, contentAspect));
            pillowSurfaceAspect = safeAspect;

            const h = PILLOW_MODEL_HEIGHT;
            const w = h * safeAspect;

            if (frontMesh) {
                pillowGroup.remove(frontMesh);
                frontMesh.geometry.dispose();
            }
            if (backMesh) {
                pillowGroup.remove(backMesh);
                backMesh.geometry.dispose();
            }

            const frontGeo = new THREE.PlaneGeometry(w, h, PILLOW_SURFACE_SEGMENTS, PILLOW_SURFACE_SEGMENTS);
            const backGeo = new THREE.PlaneGeometry(w, h, PILLOW_SURFACE_SEGMENTS, PILLOW_SURFACE_SEGMENTS);
            remapUVToGeometryBounds(frontGeo);
            remapUVToGeometryBounds(backGeo);

            frontMesh = new THREE.Mesh(frontGeo, pillowMaterial);
            backMesh = new THREE.Mesh(backGeo, pillowMaterial);
            frontMesh.position.z = PILLOW_CUTOUT_DEPTH * 0.5;
            backMesh.position.z = -PILLOW_CUTOUT_DEPTH * 0.5;
            backMesh.rotation.y = Math.PI;
            backMesh.scale.x = -1;

            pillowGroup.add(frontMesh);
            pillowGroup.add(backMesh);

            pillowGroup.scale.x = 1;
            pillowGroup.scale.y = 1;
            pillowGroup.scale.z = 1;
        }

        function rebuildSideWallFromCanvas(canvas) {
            if (!THREE || !pillowGroup || !canvas) return;

            const smoothed = smoothOutlineToModelPoints(canvas, 20, PILLOW_CONTOUR_POINT_COUNT);
            if (!smoothed) return;

            const centerX = smoothed.points2D.reduce((sum, p) => sum + p.x, 0) / smoothed.points2D.length;
            const centerY = smoothed.points2D.reduce((sum, p) => sum + p.y, 0) / smoothed.points2D.length;
            const modelOutlinePoints = smoothed.points2D.map(p => new THREE.Vector2(
                centerX + (p.x - centerX) * PILLOW_WRAP_MARGIN_SCALE,
                centerY + (p.y - centerY) * PILLOW_WRAP_MARGIN_SCALE
            ));

            if (sideMesh) {
                pillowGroup.remove(sideMesh);
                sideMesh.geometry.dispose();
                if (sideMesh.material !== pillowMaterial) sideMesh.material.dispose();
            }

            const sideGeo = createSideWallGeometry(modelOutlinePoints, PILLOW_CUTOUT_DEPTH, {
                roundSegments: 4,
                roundBulge: -0.014,
                xScale: 0.968,
                yScale: 0.968
            });
            const sideMaterial = new THREE.MeshStandardMaterial({
                color: selectedPillowColor,
                roughness: 0.95,
                metalness: 0,
                side: THREE.DoubleSide
            });
            sideMesh = new THREE.Mesh(sideGeo, sideMaterial);
            sideMesh.visible = false;
            pillowGroup.add(sideMesh);
            rebuildContourRim(modelOutlinePoints);
            applySelectedPillowColor();
        }

        function clearPreviewCanvas() {
            if (!previewCanvas) return;
            previewCanvas.width = 1;
            previewCanvas.height = 1;
            previewCanvas.getContext("2d").clearRect(0, 0, 1, 1);
        }

        function updatePreviewCanvas(sourceCanvas) {
            if (!previewCanvas) return;
            if (!sourceCanvas || sourceCanvas.width < 2 || sourceCanvas.height < 2) {
                clearPreviewCanvas();
                return;
            }
            previewCanvas.width = sourceCanvas.width;
            previewCanvas.height = sourceCanvas.height;
            const ctx = previewCanvas.getContext("2d");
            ctx.clearRect(0, 0, previewCanvas.width, previewCanvas.height);
            ctx.drawImage(sourceCanvas, 0, 0);
        }

        uploadBtn?.addEventListener("click", () => fileInput?.click());

        tab3d?.addEventListener("click", show3dScene);
        tabBackground?.addEventListener("click", showBackgroundScene);

        colorSwatches.forEach((swatch) => {
            swatch.addEventListener("click", () => {
                setPillowColor(swatch.dataset.pillowColor || "#ffffff", { repaint: true, status: true });
            });
        });

        updateCustomizerProperties();
        initVariantOptions();
        if (showHistory) {
            renderModelHistory();
            loadStoredModelHistory().catch(() => {});
        }

        async function requestBackendCutout(file, providedCacheKey = "") {
            const cacheKey = providedCacheKey || await createBackgroundRemovalCacheKey(file);
            if (cacheKey) {
                const cachedBlob = bgRemovalMemoryCache.get(cacheKey) || await readBackgroundRemovalCache(cacheKey);
                if (cachedBlob) {
                    bgRemovalMemoryCache.set(cacheKey, cachedBlob);
                    return cloneBlob(cachedBlob);
                }

                if (bgRemovalPendingRequests.has(cacheKey)) {
                    return cloneBlob(await bgRemovalPendingRequests.get(cacheKey));
                }
            }

            const requestPromise = fetchBackgroundRemovalBlob(file)
                .then(async (blob) => {
                    if (cacheKey) {
                        bgRemovalMemoryCache.set(cacheKey, blob);
                        await writeBackgroundRemovalCache(cacheKey, blob).catch(() => {});
                        trimBackgroundRemovalCache().catch(() => {});
                    }
                    return blob;
                })
                .finally(() => {
                    if (cacheKey) bgRemovalPendingRequests.delete(cacheKey);
                });

            if (cacheKey) bgRemovalPendingRequests.set(cacheKey, requestPromise);
            return cloneBlob(await requestPromise);
        }

        function renderModelHistory() {
            if (!showHistory) return;
            if (!historyPanel || !historyList) return;
            historyPanel.classList.add("has-items");
            historyList.innerHTML = "";

            modelHistoryEntries.forEach((entry, index) => {
                const isActive = entry.key === activeHistoryKey;
                const button = document.createElement("button");
                button.type = "button";
                button.className = "history-item";
                button.classList.toggle("is-active", isActive);
                button.dataset.historyKey = entry.key;
                button.setAttribute("aria-label", entry.name || `History ${index + 1}`);
                if (isActive) button.setAttribute("aria-current", "true");

                const img = document.createElement("img");
                img.src = entry.previewUrl;
                img.alt = entry.name || "";
                img.loading = "lazy";
                button.appendChild(img);

                button.addEventListener("click", () => {
                    if (entry.key === activeHistoryKey) return;
                    restoreModelHistoryEntry(entry.key);
                });
                historyList.appendChild(button);
            });

            const uploadButton = document.createElement("button");
            uploadButton.type = "button";
            uploadButton.className = "history-item history-upload";
            uploadButton.setAttribute("aria-label", "Upload image");

            const uploadIcon = document.createElement("span");
            uploadIcon.className = "history-upload-icon";
            uploadIcon.setAttribute("aria-hidden", "true");
            uploadIcon.textContent = "+";

            uploadButton.appendChild(uploadIcon);
            uploadButton.addEventListener("click", () => fileInput?.click());
            historyList.appendChild(uploadButton);
        }

        function addModelHistoryEntry({ key, name, cutoutBlob, previewUrl, originalBlob, originalUrl }) {
            if (!showHistory) return;
            if (!key || !cutoutBlob || !previewUrl) return;
            const existingIndex = modelHistoryEntries.findIndex((entry) => entry.key === key);
            const entry = {
                key,
                name: name || "3D model",
                cutoutBlob: cloneBlob(cutoutBlob),
                previewUrl,
                pillowColor: selectedPillowColor,
                selectedOptions: [...selectedOptions],
                originalBlob: originalBlob ? cloneBlob(originalBlob) : undefined,
                originalUrl: originalUrl || "",
                createdAt: Date.now()
            };

            if (existingIndex >= 0) modelHistoryEntries.splice(existingIndex, 1);
            modelHistoryEntries.unshift(entry);
            modelHistoryEntries.splice(BG_REMOVAL_CACHE_MAX_ENTRIES);
            activeHistoryKey = key;
            renderModelHistory();
            writeModelHistoryEntry(entry).catch(() => {});
        }

        async function restoreModelHistoryEntry(key) {
            if (!showHistory) return;
            if (key && key === activeHistoryKey) return;
            const entry = modelHistoryEntries.find((item) => item.key === key);
            if (!entry?.cutoutBlob) return;

            try {
                setStatus("Loading history...", true);
                showProgress(-1);
                setModelPreviewLoading(true);

                const imageBitmap = await createImageBitmap(entry.cutoutBlob);
                clearCachedCutout();
                cachedCutoutBitmap = imageBitmap;
                if (entry.pillowColor) setPillowColor(entry.pillowColor, { repaint: false, status: false });
                if (entry.selectedOptions) restoreSelectedOptions(entry.selectedOptions);

                const rawCutoutCanvas = createRawCutoutCanvas(imageBitmap);
                if (!rawCutoutCanvas) throw new Error("History image could not be loaded.");

                currentRawCutoutCanvas = cloneCanvas(rawCutoutCanvas);
                currentCutoutCanvas = cloneCanvas(rawCutoutCanvas);
                const outlinedCanvas = addOutlineRing(rawCutoutCanvas, 20);
                const modelCanvas = rebuildModelFromCutoutCanvas(outlinedCanvas);
                if (!modelCanvas) throw new Error("History model could not be rebuilt.");

                uploadedCutoutUrl = "";
                uploadedCutoutFilename = "";
                uploadedModelUrl = "";
                uploadedModelFilename = "";
                uploadedOriginalUrl = entry.originalUrl || "";
                if (entry.originalBlob) {
                    selectedFile = new File([entry.originalBlob], entry.name || "original", { type: entry.originalBlob.type || "image/png" });
                }
                activeHistoryKey = key;

                dropHint?.classList.add("hidden");
                presentBuiltModel(() => {
                    setModelPreviewState(captureTransparentModelImage() || entry.previewUrl);
                    setModelPreviewLoading(false);
                });
                updateCustomizerProperties();
                const buyHost = customizerRoot.querySelector("#buyHost");
                if (buyHost) buyHost.classList.remove("hidden");
                renderModelHistory();
                hideProgress();
                setStatus("");
            } catch (error) {
                console.error(error);
                hideProgress();
                setModelPreviewLoading(false);
                setStatus(error?.message || "History load failed.");
            }
        }

        async function fetchBackgroundRemovalBlob(file) {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("format", "png");
            formData.append("quality", "95");

            const response = await fetch(BACKGROUND_REMOVAL_API_URL, {
                method: "POST",
                body: formData
            });

            if (!response.ok) {
                const message = await response.text().catch(() => "");
                throw new Error(message || `remove-background ${response.status}`);
            }

            return response.blob();
        }

        function cloneBlob(blob) {
            return blob?.slice ? blob.slice(0, blob.size, blob.type) : blob;
        }

        async function createBackgroundRemovalCacheKey(file) {
            if (!file) return "";
            const endpointKey = BACKGROUND_REMOVAL_API_URL || "default";
            const fallbackKey = `${endpointKey}|${file.name || "image"}|${file.size || 0}|${file.lastModified || 0}`;

            if (!window.crypto?.subtle || !file.arrayBuffer) return fallbackKey;

            try {
                const buffer = await file.arrayBuffer();
                const digest = await window.crypto.subtle.digest("SHA-256", buffer);
                const hash = [...new Uint8Array(digest)]
                    .map((byte) => byte.toString(16).padStart(2, "0"))
                    .join("");
                return `${endpointKey}|sha256:${hash}|png|95`;
            } catch (error) {
                return fallbackKey;
            }
        }

        function openBackgroundRemovalCache() {
            return new Promise((resolve, reject) => {
                if (!window.indexedDB) {
                    reject(new Error("IndexedDB is unavailable."));
                    return;
                }

                const request = window.indexedDB.open(BG_REMOVAL_CACHE_DB, BG_REMOVAL_CACHE_VERSION);

                request.onupgradeneeded = () => {
                    const db = request.result;
                    if (!db.objectStoreNames.contains(BG_REMOVAL_CACHE_STORE)) {
                        db.createObjectStore(BG_REMOVAL_CACHE_STORE, { keyPath: "key" });
                    }
                };

                request.onsuccess = () => resolve(request.result);
                request.onerror = () => reject(request.error || new Error("IndexedDB open failed."));
            });
        }

        async function withBackgroundRemovalStore(mode, callback) {
            const db = await openBackgroundRemovalCache();

            return new Promise((resolve, reject) => {
                const transaction = db.transaction(BG_REMOVAL_CACHE_STORE, mode);
                const store = transaction.objectStore(BG_REMOVAL_CACHE_STORE);
                let callbackResult;
                let settled = false;

                const finish = (handler, value) => {
                    if (settled) return;
                    settled = true;
                    db.close();
                    handler(value);
                };

                transaction.oncomplete = () => {
                    finish(resolve, callbackResult);
                };
                transaction.onerror = () => {
                    finish(reject, transaction.error || new Error("IndexedDB transaction failed."));
                };
                transaction.onabort = () => {
                    finish(reject, transaction.error || new Error("IndexedDB transaction aborted."));
                };

                try {
                    callbackResult = callback(store);
                } catch (error) {
                    try {
                        transaction.abort();
                    } catch (abortError) {
                        finish(reject, error);
                    }
                }
            });
        }

        async function readBackgroundRemovalCache(key) {
            if (!key) return null;

            return withBackgroundRemovalStore("readonly", (store) => {
                return new Promise((resolve) => {
                    const request = store.get(key);
                    request.onsuccess = () => {
                        const record = request.result;
                        if (!record?.blob) {
                            resolve(null);
                            return;
                        }

                        if (Date.now() - (record.createdAt || 0) > BG_REMOVAL_CACHE_MAX_AGE_MS) {
                            resolve(null);
                            return;
                        }

                        resolve(record.blob);
                    };
                    request.onerror = () => resolve(null);
                });
            }).catch(() => null);
        }

        async function writeBackgroundRemovalCache(key, blob) {
            if (!key || !blob) return;

            await withBackgroundRemovalStore("readwrite", (store) => {
                store.put({
                    key,
                    blob,
                    createdAt: Date.now(),
                    size: blob.size || 0,
                    type: blob.type || "image/png"
                });
            });
        }

        async function writeModelHistoryEntry(entry) {
            if (!showHistory) return;
            if (!entry?.key || !entry.cutoutBlob || !entry.previewUrl) return;

            await withBackgroundRemovalStore("readwrite", (store) => {
                store.put({
                    key: entry.key,
                    blob: cloneBlob(entry.cutoutBlob),
                    previewUrl: entry.previewUrl,
                    pillowColor: entry.pillowColor || selectedPillowColor,
                    selectedOptions: Array.isArray(entry.selectedOptions) ? [...entry.selectedOptions] : [],
                    name: entry.name || "3D model",
                    createdAt: entry.createdAt || Date.now(),
                    size: entry.cutoutBlob.size || 0,
                    type: entry.cutoutBlob.type || "image/png",
                    originalBlob: entry.originalBlob ? cloneBlob(entry.originalBlob) : undefined,
                    originalUrl: entry.originalUrl || ""
                });
            });
        }

        async function loadStoredModelHistory() {
            if (!showHistory) return;
            const records = await withBackgroundRemovalStore("readonly", (store) => {
                return new Promise((resolve) => {
                    const request = store.getAll();
                    request.onsuccess = () => resolve(request.result || []);
                    request.onerror = () => resolve([]);
                });
            }).catch(() => []);

            const now = Date.now();
            const historyRecords = records
                .filter((record) => record?.blob && record.previewUrl)
                .filter((record) => now - (record.createdAt || 0) <= BG_REMOVAL_CACHE_MAX_AGE_MS)
                .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))
                .slice(0, BG_REMOVAL_CACHE_MAX_ENTRIES);

            historyRecords.forEach((record) => {
                if (modelHistoryEntries.some((entry) => entry.key === record.key)) return;
                modelHistoryEntries.push({
                    key: record.key,
                    name: record.name || "3D model",
                    cutoutBlob: cloneBlob(record.blob),
                    previewUrl: record.previewUrl,
                    pillowColor: record.pillowColor || "",
                    selectedOptions: Array.isArray(record.selectedOptions) ? [...record.selectedOptions] : [],
                    originalBlob: record.originalBlob ? cloneBlob(record.originalBlob) : undefined,
                    originalUrl: record.originalUrl || "",
                    createdAt: record.createdAt || Date.now()
                });
            });

            renderModelHistory();
        }

        async function trimBackgroundRemovalCache() {
            await withBackgroundRemovalStore("readwrite", (store) => {
                const request = store.getAll();
                request.onsuccess = () => {
                    const records = request.result || [];
                    const now = Date.now();
                    const expired = records.filter((record) => now - (record.createdAt || 0) > BG_REMOVAL_CACHE_MAX_AGE_MS);
                    expired.forEach((record) => store.delete(record.key));

                    records
                        .filter((record) => now - (record.createdAt || 0) <= BG_REMOVAL_CACHE_MAX_AGE_MS)
                        .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))
                        .slice(BG_REMOVAL_CACHE_MAX_ENTRIES)
                        .forEach((record) => store.delete(record.key));
                };
            });
        }

        async function runAutoCutoutFlow() {
            if (!selectedFile) return;

            setStageVisible(true);
            setModelVisible(false);
            dropHint?.classList.remove("hidden");
            setModelPreviewLoading(true);
            setStatus("Generating 3D model, please wait...", true);
            showProgress(-1);

            try {
                if (window.location.protocol === "file:") {
                    throw new Error("Please open this page through an HTTP server. file:// blocks module loading.");
                }

                showProgress(-1);
                setStatus("Requesting background removal...", true);
                const cacheKey = await createBackgroundRemovalCacheKey(selectedFile);
                const outputBlob = await requestBackendCutout(selectedFile, cacheKey);
                const imageBitmap = await createImageBitmap(outputBlob);

                setStatus("Processing cutout...", true);
                showProgress(-1);

                clearCachedCutout();
                cachedCutoutBitmap = imageBitmap;
                const rawCutoutCanvas = createRawCutoutCanvas(imageBitmap);
                if (!rawCutoutCanvas) throw new Error("Cutout canvas could not be created.");
                currentRawCutoutCanvas = cloneCanvas(rawCutoutCanvas);
                currentCutoutCanvas = cloneCanvas(rawCutoutCanvas);
                const outlinedCanvas = addOutlineRing(rawCutoutCanvas, 20);
                const modelCanvas = rebuildModelFromCutoutCanvas(outlinedCanvas);
                if (!modelCanvas) throw new Error("3D model canvas could not be created.");

                setStatus("Building 3D model...", true);
                showProgress(-1);
                presentBuiltModel(() => {
                    const modelPreviewUrl = captureTransparentModelImage();
                    setModelPreviewState(modelPreviewUrl);
                    setModelPreviewLoading(false);
                    addModelHistoryEntry({
                        key: cacheKey,
                        name: selectedFile.name || "3D model",
                        cutoutBlob: outputBlob,
                        previewUrl: modelPreviewUrl || captureModelScreenshot(),
                        originalBlob: selectedFile,
                        originalUrl: uploadedOriginalUrl
                    });
                });
                updateCustomizerProperties();

                setStatus("3D model generated.", true);
                showProgress(-1);
                const buyHost = customizerRoot.querySelector("#buyHost");
                if (buyHost) buyHost.classList.remove("hidden");
                window.setTimeout(() => {
                    hideProgress();
                    setStatus("");
                }, 320);
            } catch (err) {
                console.error(err);
                hideProgress();
                setModelPreviewLoading(false);
                setStageVisible(true);
                setModelVisible(false);
                setDropHintCompactState(false);
                dropHint?.classList.remove("hidden");
                currentRawCutoutCanvas = null;
                currentCutoutCanvas = null;
                currentModelCanvas = null;
                setModelPreviewState("");
                uploadedCutoutUrl = "";
                uploadedCutoutFilename = "";
                updateCustomizerProperties();
                const buyHost = customizerRoot.querySelector("#buyHost");
                if (buyHost) buyHost.classList.add("hidden");
                const message = err?.message ? `Cutout failed: ${err.message}` : "Cutout failed. Please try again or choose another image.";
                setStatus(message);
            }
        }

        fileInput?.addEventListener("change", async () => {
            const [file] = fileInput.files || [];
            selectedFile = file || null;
            clearCachedCutout();

            if (selectedUrl) {
                URL.revokeObjectURL(selectedUrl);
                selectedUrl = "";
            }

            if (!selectedFile) {
                clearPreviewCanvas();
                setModelPreviewState("");
                setModelPreviewLoading(false);
                setDropHintCompactState(false);
                currentRawCutoutCanvas = null;
                currentCutoutCanvas = null;
                currentModelCanvas = null;
                uploadedCutoutUrl = "";
                uploadedCutoutFilename = "";
                uploadedModelUrl = "";
                uploadedModelFilename = "";
                uploadedOriginalUrl = "";
                updateCustomizerProperties();
                setStageVisible(true);
                setModelVisible(false);
                dropHint?.classList.remove("hidden");
                const buyHost = customizerRoot.querySelector("#buyHost");
                if (buyHost) buyHost.classList.add("hidden");
                setStatus("Please choose an image.");
                return;
            }

            currentRawCutoutCanvas = null;
            uploadedCutoutUrl = "";
            uploadedCutoutFilename = "";
            uploadedModelUrl = "";
            uploadedModelFilename = "";
            uploadedOriginalUrl = "";
            updateCustomizerProperties();
            setMediaShellState(false);
            setDropHintCompactState(false);
            selectedUrl = URL.createObjectURL(selectedFile);
            setStageVisible(true);
            setModelVisible(false);
            setStatus(`Selected ${selectedFile.name}. Generating automatically...`, true);
            dropHint?.classList.remove("hidden");
            await runAutoCutoutFlow();
        });


        async function initThreeScene() {
            try {
                const threeModule = await import(THREE_MODULE_URL);
                THREE = threeModule;

                scene = new THREE.Scene();
                camera = new THREE.OrthographicCamera(-3.6, 3.6, 3.6, -3.6, 0.1, 100);
                camera.position.set(0, 0.3, 5.2);
                camera.lookAt(0, 0, 0);

                renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: true });
                renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.5));
                renderer.outputColorSpace = THREE.SRGBColorSpace;
                stage3d?.appendChild(renderer.domElement);

                controls = createLocalModelControls(renderer.domElement);
                controls.update();

                scene.add(new THREE.AmbientLight(0xffffff, 1.5));
                const keyLight = new THREE.DirectionalLight(0xffffff, 1.08);
                keyLight.position.set(2.4, 3.2, 2.2);
                scene.add(keyLight);
                const rimLight = new THREE.DirectionalLight(0xf8fafc, 1.05);
                rimLight.position.set(-2.4, 1.4, -3.2);
                scene.add(rimLight);

                pillowMaterial = new THREE.MeshStandardMaterial({
                    color: selectedPillowColor,
                    transparent: true,
                    roughness: 0.95,
                    metalness: 0,
                    alphaMap: null,
                    alphaTest: 0.08,
                    toneMapped: false
                });

                window.addEventListener("resize", resize3D);
                resize3D();
                renderLoop();

                setStatus("3D pillow is ready. Upload a photo to preview.");
            } catch (err) {
                console.error(err);
                const errorBox = document.createElement("div");
                errorBox.style.cssText = "position:absolute;inset:16px;color:#6b7280;font-size:13px;z-index:6;";
                errorBox.textContent = "3D module failed to load. Please check the network or module URL.";
                stage3d?.appendChild(errorBox);
            }
        }

        clearPreviewCanvas();
        setStageVisible(true);


});


